/**
 * @brief this will fix the undefined console problem in older versions of IE
 * @warning this is the most generic way of writing this, not using 3rd party libraries
 *          and making it work in any browser.
 */
if (!window.console) {
    window.console = {
      log: function() {},
      warn: function() {},
      error: function() {}
    };
}

// from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/isNaN
Number.isNaN = Number.isNaN || function isNaN(input) {
  return typeof input === 'number' && input !== input;
}

Number.isInteger = Number.isInteger || function(value) {
  return typeof value === 'number' && 
    isFinite(value) && 
    Math.floor(value) === value;
};

if (window.Number !== undefined && Number.EPSILON === undefined) {
    Number.EPSILON = Math.pow(2, -52);
}

// decomment next line to test of the polyfill is added at the proper time, 
// window.testAlert = function(){}

if (!window.location.origin) {
  window.location.origin = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port: '');
}

/**
 * polyfill for Function
 */
// from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind
if (!Function.prototype.bind) {
  Function.prototype.bind = function (oThis) {
    if (typeof this !== 'function') {
      throw new TypeError('Function.prototype.bind - what is trying to be bound is not callable');
    }
    var args = Array.prototype.slice.call(arguments, 1);
    var fToBind = this;
    var fNOP = function () {};
    var fBound = function () {
      return fToBind.apply(this instanceof fNOP ? this : oThis, args.concat(Array.prototype.slice.call(arguments)));
    };

    if (this.prototype) {
      fNOP.prototype = this.prototype;
    }
    fBound.prototype = new fNOP();
    return fBound;
  };
}
/**
 * polyfill for Object
 */

/**
 * String.prototype.replaceAll() polyfill
 * https://gomakethings.com/how-to-replace-a-section-of-a-string-with-another-one-with-vanilla-js/
 * @author Chris Ferdinandi
 * @license MIT
 */
 if (!String.prototype.replaceAll) {
  Object.defineProperty(String.prototype, "replaceAll", {
      value: function (str, newStr) {
          // If a regex pattern
          if (Object.prototype.toString.call(str).toLowerCase() === '[object regexp]') {
            return this.replace(str, newStr);
          }

          // If a string
          // consider each char as real char and not as reg exp, so esacpe each char
          str = str.replace(new RegExp("(.)", "g"), "[$1]");
          return this.replace(new RegExp(str, 'g'), newStr);
      }
	})
}



// from https://github.com/es-shims/es5-shim/blob/master/es5-sham.js
(function () {
  var prototypeOfObject = Object.prototype;
  var call = Function.call;
  var owns = call.bind(prototypeOfObject.hasOwnProperty);
  var isEnumerable = call.bind(prototypeOfObject.propertyIsEnumerable);
  var toStr = call.bind(prototypeOfObject.toString);

  var defineGetter;
  var defineSetter;
  var lookupGetter;
  var lookupSetter;
  var supportsAccessors = owns(prototypeOfObject, '__defineGetter__');
  if (supportsAccessors) {
    /* eslint-disable no-underscore-dangle, no-restricted-properties */
    defineGetter = call.bind(prototypeOfObject.__defineGetter__);
    defineSetter = call.bind(prototypeOfObject.__defineSetter__);
    lookupGetter = call.bind(prototypeOfObject.__lookupGetter__);
    lookupSetter = call.bind(prototypeOfObject.__lookupSetter__);
    /* eslint-enable no-underscore-dangle, no-restricted-properties */
  }

  var isPrimitive = function isPrimitive(o) {
    return o == null || (typeof o !== 'object' && typeof o !== 'function');
  };

  if (!Object.getPrototypeOf) {
    Object.getPrototypeOf = function getPrototypeOf(object) {
      var proto = object.__proto__;
      if (proto || proto === null) {
        return proto;
      }
      if (toStr(object.constructor) === '[object Function]') {
        return object.constructor.prototype;
      }
      if (object instanceof Object) {
        return prototypeOfObject;
      }
      return null;
    };
  }

  if (!Object.keys) {
    Object.keys = (function() {
      var hasOwnProperty = Object.prototype.hasOwnProperty;
      var hasDontEnumBug = !({ toString: null }).propertyIsEnumerable('toString');
      var dontEnums = [
        'toString',
        'toLocaleString',
        'valueOf',
        'hasOwnProperty',
        'isPrototypeOf',
        'propertyIsEnumerable',
        'constructor'
      ];
      var dontEnumsLength = dontEnums.length;

      return function (obj) {
        if (typeof obj !== 'object' && (typeof obj !== 'function' || obj === null)) {
          throw new TypeError('Object.keys called on non-object');
        }
        var result = [], prop, i;

        for (prop in obj) {
          if (hasOwnProperty.call(obj, prop)) {
            result.push(prop);
          }
        }
        if (hasDontEnumBug) {
          for (i = 0; i < dontEnumsLength; i++) {
            if (hasOwnProperty.call(obj, dontEnums[i])) {
              result.push(dontEnums[i]);
            }
          }
        }
        return result;
      };
    }());
  }

  if (!Object.getOwnPropertyNames) {
    Object.getOwnPropertyNames = function getOwnPropertyNames(object) {
      if (object !== Object(object)) {
        throw TypeError('Object.getOwnPropertyNames called on non-object: ' + object);
      }
      return Object.keys(object);
    };
  }

  var doesGetOwnPropertyDescriptorWork = function doesGetOwnPropertyDescriptorWork(object) {
    try {
      object.sentinel = 0;
      return Object.getOwnPropertyDescriptor(object, 'sentinel').value === 0;
    } catch (err) {
      return false;
    }
  };
  var getOwnPropertyDescriptorFallback;
  if (Object.defineProperty) {
    var getOwnPropertyDescriptorWorksOnObject = doesGetOwnPropertyDescriptorWork({});
    var getOwnPropertyDescriptorWorksOnDom = typeof document === 'undefined' ||
      doesGetOwnPropertyDescriptorWork(document.createElement('div'));
    if (!getOwnPropertyDescriptorWorksOnDom || !getOwnPropertyDescriptorWorksOnObject) {
      getOwnPropertyDescriptorFallback = Object.getOwnPropertyDescriptor;
    }
  }
  if (!Object.getOwnPropertyDescriptor || getOwnPropertyDescriptorFallback) {
    var ERR_NON_OBJECT = 'Object.getOwnPropertyDescriptor called on a non-object: ';
    Object.getOwnPropertyDescriptor = function getOwnPropertyDescriptor(object, property) {
      if (isPrimitive(object)) {
        throw new TypeError(ERR_NON_OBJECT + object);
      }
      if (getOwnPropertyDescriptorFallback) {
        try {
          return getOwnPropertyDescriptorFallback.call(Object, object, property);
        } catch (err) {

        }
      }
      var descriptor;
      if (!owns(object, property)) {
        return descriptor;
      }
      descriptor = {
        enumerable: isEnumerable(object, property),
        configurable: true
      };
      if (supportsAccessors) {
        var prototype = object.__proto__;
        var notPrototypeOfObject = object !== prototypeOfObject;
        if (notPrototypeOfObject) {
          object.__proto__ = prototypeOfObject;
        }
        var getter = lookupGetter(object, property);
        var setter = lookupSetter(object, property);
        if (notPrototypeOfObject) {
          object.__proto__ = prototype;
        }
        if (getter || setter) {
          if (getter) {
            descriptor.get = getter;
          }
          if (setter) {
            descriptor.set = setter;
          }
          return descriptor;
        }
      }
      descriptor.value = object[property];
      descriptor.writable = true;
      return descriptor;
    };
  }

  var doesDefinePropertyWork = function doesDefinePropertyWork(object) {
    try {
      Object.defineProperty(object, 'sentinel', {});
      return 'sentinel' in object;
    } catch (exception) {
      return false;
    }
  };

  if (Object.defineProperty) {
    var definePropertyWorksOnObject = doesDefinePropertyWork({});
    var definePropertyWorksOnDom = typeof document === 'undefined' ||
      doesDefinePropertyWork(document.createElement('div'));
    if (!definePropertyWorksOnObject || !definePropertyWorksOnDom) {
      var definePropertyFallback = Object.defineProperty;
      var definePropertiesFallback = Object.defineProperties;
    }
  }

  if (!Object.defineProperty || definePropertyFallback) {
    var ERR_NON_OBJECT_DESCRIPTOR = 'Property description must be an object: ';
    var ERR_NON_OBJECT_TARGET = 'Object.defineProperty called on non-object: ';
    var ERR_ACCESSORS_NOT_SUPPORTED = 'getters & setters can not be defined on this javascript engine';
    Object.defineProperty = function defineProperty(object, property, descriptor) {
      if (isPrimitive(object)) {
        throw new TypeError(ERR_NON_OBJECT_TARGET + object);
      }
      if (isPrimitive(descriptor)) {
        throw new TypeError(ERR_NON_OBJECT_DESCRIPTOR + descriptor);
      }
      if (definePropertyFallback) {
        try {
          return definePropertyFallback.call(Object, object, property, descriptor);
        } catch (exception) {
        }
      }
      if ('value' in descriptor) {
        if (supportsAccessors && (lookupGetter(object, property) || lookupSetter(object, property))) {
          var prototype = object.__proto__;
          object.__proto__ = prototypeOfObject;
          delete object[property];
          object[property] = descriptor.value;
          object.__proto__ = prototype;
        } else {
          object[property] = descriptor.value;
        }
      } else {
        var hasGetter = 'get' in descriptor;
        var hasSetter = 'set' in descriptor;
        if (!supportsAccessors && (hasGetter || hasSetter)) {
          return object;
        }
        // If we got that far then getters and setters can be defined !!
        if (hasGetter) {
          defineGetter(object, property, descriptor.get);
        }
        if (hasSetter) {
          defineSetter(object, property, descriptor.set);
        }
      }
      return object;
    };
  }

  if (!Object.defineProperties || definePropertiesFallback) {
    Object.defineProperties = function defineProperties(object, properties) {
      if (definePropertiesFallback) {
        try {
          return definePropertiesFallback.call(Object, object, properties);
        } catch (exception) {
        }
      }
      var keys = Object.keys(properties);
      for (var i = 0; i < keys.length; i++) {
        var property = keys[i];
        if (property !== '__proto__') {
          Object.defineProperty(object, property, properties[property]);
        }
      }
      return object;
    };
  }

  if (!Object.create) {
    var createEmpty;
    var supportsProto = !({ __proto__: null } instanceof Object);
    /* global ActiveXObject */
    var shouldUseActiveX = function () {
      if (!document.domain) {
        return false;
      }
      try {
        return !!new ActiveXObject('htmlfile');
      } catch (exception) {
        return false;
      }
    };

    var getEmptyViaActiveX = function () {
      var empty;
      var xDoc;
      xDoc = new ActiveXObject('htmlfile');
      var script = 'script';
      xDoc.write('<' + script + '></' + script + '>');
      xDoc.close();

      empty = xDoc.parentWindow.Object.prototype;
      xDoc = null;

      return empty;
    };

    var getEmptyViaIFrame = function () {
      var iframe = document.createElement('iframe');
      var parent = document.body || document.documentElement;
      var empty;

      iframe.style.display = 'none';
      parent.appendChild(iframe);
      // eslint-disable-next-line no-script-url
      iframe.src = 'javascript:';

      empty = iframe.contentWindow.Object.prototype;
      parent.removeChild(iframe);
      iframe = null;

      return empty;
    };

    /* global document */
    if (supportsProto || typeof document === 'undefined') {
      createEmpty = function () {
        return { __proto__: null };
      };
    } else {
      createEmpty = function () {
        var empty = shouldUseActiveX() ? getEmptyViaActiveX() : getEmptyViaIFrame();

        delete empty.constructor;
        delete empty.hasOwnProperty;
        delete empty.propertyIsEnumerable;
        delete empty.isPrototypeOf;
        delete empty.toLocaleString;
        delete empty.toString;
        delete empty.valueOf;

        var Empty = function Empty() { };
        Empty.prototype = empty;
        // short-circuit future calls
        createEmpty = function () {
          return new Empty();
        };
        return new Empty();
      };
    }

    Object.create = function create (prototype, properties) {
      var object;
      var Type = function () { };
      if (prototype === null) {
        object = createEmpty();
      } else {
        if (prototype !== null && isPrimitive(prototype)) {
          throw new TypeError('Object prototype may only be an Object or null');
        }
        Type.prototype = prototype;
        object = new Type();
        object.__proto__ = prototype;
      }

      if (properties !== void 0) {
        Object.defineProperties(object, properties);
      }

      return object;
    };
  }

  if (!Object.seal) {
    Object.seal = function seal(object) {
      if (Object(object) !== object) {
        throw new TypeError('Object.seal can only be called on Objects.');
      }
      return object;
    };
  }

  if (!Object.freeze) {
    Object.freeze = function freeze(object) {
      if (Object(object) !== object) {
        throw new TypeError('Object.freeze can only be called on Objects.');
      }
      return object;
    };
  }

  try {
    Object.freeze(function () { });
  } catch (exception) {
    Object.freeze = (function (freezeObject) {
      return function freeze(object) {
        if (typeof object === 'function') {
          return object;
        }
        return freezeObject(object);
      };
    })(Object.freeze);
  }

  if (!Object.preventExtensions) {
    Object.preventExtensions = function preventExtensions(object) {
      if (Object(object) !== object) {
        throw new TypeError('Object.preventExtensions can only be called on Objects.');
      }
      return object;
    };
  }

  if (!Object.isSealed) {
    Object.isSealed = function isSealed(object) {
      if (Object(object) !== object) {
        throw new TypeError('Object.isSealed can only be called on Objects.');
      }
      return false;
    };
  }

  if (!Object.isFrozen) {
    Object.isFrozen = function isFrozen(object) {
      if (Object(object) !== object) {
        throw new TypeError('Object.isFrozen can only be called on Objects.');
      }
      return false;
    };
  }

  if (!Object.isExtensible) {
    Object.isExtensible = function isExtensible(object) {
      if (Object(object) !== object) {
        throw new TypeError('Object.isExtensible can only be called on Objects.');
      }
      var name = '';
      while (owns(object, name)) {
        name += '?';
      }
      object[name] = true;
      var returnValue = owns(object, name);
      delete object[name];
      return returnValue;
    };
  }
  
    if (typeof Object.assign != 'function') {
      // Must be writable: true, enumerable: false, configurable: true
      Object.defineProperty(Object, "assign", {
        value: function assign(target, varArgs) { // .length of function is 2
          'use strict';
          if (target == null) { // TypeError if undefined or null
              throw new TypeError('Cannot convert undefined or null to object');
          }

          var to = Object(target);

          for (var index = 1; index < arguments.length; index++) {
              var nextSource = arguments[index];

              if (nextSource != null) { // Skip over if undefined or null
                  for (var nextKey in nextSource) {
                      // Avoid bugs when hasOwnProperty is shadowed
                      if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                          to[nextKey] = nextSource[nextKey];
                      }
                  }
              }
          }
          return to;
          },
          writable: true,
          configurable: true
      });
  }

  if (!Object.is) {
      Object.is = function(x, y) {
          // SameValue algorithm
          if (x === y) { // Steps 1-5, 7-10
              // Steps 6.b-6.e: +0 != -0
              return x !== 0 || 1 / x === 1 / y;
          } else {
              // Step 6.a: NaN == NaN
              return x !== x && y !== y;
          }
      };
  }

  if (!Object.values) {
    Object.values = function(obj){
      var res = [];
      for (var i in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, i)) {
              res.push(obj[i]);
          }
      }
      return res;
    }
  }

  if (!Object.entries) {
    Object.entries = function (obj){
      var ownProps = Object.keys(obj),
        i = ownProps.length,
        resArray = new Array(i); // preallocate the Array
  
      while (i--) {
        resArray[i] = [ownProps[i], obj[ownProps[i]]];
      }
      return resArray;
  
    };
  }

  if (!Object.hasOwn) {
    Object.hasOwn = function(obj, prop){
      return Object.prototype.hasOwnProperty.call(obj, prop);
    }
  }
})();

/*
if (window.Error && !Error.isError) {
    Error.Error = function(arg){
      if (!arg || (typeof arg !== "object" && typeof arg !== "function")) {
        return false; // step 1
      }

      if (typeof DOMError !== "undefined" && arg instanceof DOMError) {
        // Edge 80
        return true;
      }
      if (typeof DOMException !== "undefined" && arg instanceof DOMException) {
        return true;
      }
      return arg instanceof Error;
    }
}
*/

/**
 * polyfill for Array
 */
// from https://developer.mozilla.org/zh-CN/docs/Web/JavaScript/Reference/Global_Objects/Array/isArray
if (!Array.isArray) {
  Array.isArray = function (arg) {
    return Object.prototype.toString.call(arg) === '[object Array]';
  };
}

// from https://developer.mozilla.org/zh-CN/docs/Web/JavaScript/Reference/Global_Objects/Array/forEach
if (!Array.prototype.forEach) {
    Object.defineProperty(Array.prototype, "forEach", {
        value: function (callback, thisArg) {
            var T, k;
            if (this === void 0 || this === null) {
                throw new TypeError('Array.prototype.forEach called on null or undefined');
            }
            var O = Object(this);
            var len = O.length >>> 0;
            if (Object.prototype.toString.call(callback) != '[object Function]') {
                throw new TypeError(callback + ' is not a function');
            }
            if (arguments.length > 1) {
                T = thisArg;
            }
            k = 0;
            while (k < len) {
                var kValue;
                if (k in O) {
                    kValue = O[k];
                    callback.call(T, kValue, k, O);
                }
                k++;
            }
        }
    });
}

// form https://developer.mozilla.org/zh-CN/docs/Web/JavaScript/Reference/Global_Objects/Array/every
if (!Array.prototype.every) {
    Object.defineProperty(Array.prototype, "every", {
        value: function (callback) {
            if (this === void 0 || this === null) {
                throw new TypeError('Array.prototype.every called on null or undefined');
            }

            var O = Object(this);
            var len = O.length >>> 0;
            if (Object.prototype.toString.call(callback) != '[object Function]') {
                throw new TypeError(callback + ' is not a function');
            }
            var ctx = arguments.length >= 2 ? arguments[1] : void 0;
            for (var i = 0; i < len; i++) {
                if (i in O && !callback.call(ctx, O[i], i, O)) {
                    return false;
                }
            }

            return true;
        }
    });
}

// from https://developer.mozilla.org/zh-CN/docs/Web/JavaScript/Reference/Global_Objects/Array/fill
if (!Array.prototype.fill) {
    Object.defineProperty(Array.prototype, "fill", {
        value: function (value) {
            if (this === void 0 || this === null) {
                throw new TypeError('Array.prototype.fill called on null or undefined');
            }
            var O = Object(this);
            var len = O.length >>> 0;
            var start = arguments[1];
            var relativeStart = start >> 0;
            var k = relativeStart < 0 ?
                Math.max(len + relativeStart, 0) :
                Math.min(relativeStart, len);

            var end = arguments[2];
            var relativeEnd = end === undefined ? len : end >> 0;
            var final = relativeEnd < 0 ? Math.max(len + relativeEnd, 0) : Math.min(relativeEnd, len);
            while (k < final) {
                O[k] = value;
                k++;
            }

            return O;
        }
    });
}

// from https://developer.mozilla.org/zh-CN/docs/Web/JavaScript/Reference/Global_Objects/Array/filter
if (!Array.prototype.filter) {
    Object.defineProperty(Array.prototype, "filter", {
        value: function (callback) {
            if (this === void 0 || this === null) {
                throw new TypeError('Array.prototype.filter called on null or undefined');
            }
            var O = Object(this);
            var len = O.length >>> 0;
            if (Object.prototype.toString.call(callback) != '[object Function]') {
                throw new TypeError(callback + ' is not a function');
            }
            var res = [];
            var ctx = arguments.length >= 2 ? arguments[1] : void 0;
            for (var i = 0; i < len; i++) {
                if (i in O) {
                    var val = O[i];
                    if (callback.call(ctx, val, i, O)) {
                        res.push(val);
                    }
                }
            }
            return res;
        }
    });
}

// from https://developer.mozilla.org/zh-CN/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf
if (!Array.prototype.indexOf) {
    Object.defineProperty(Array.prototype, "indexOf", {
        value: function (searchElement, fromIndex) {
            if (this === void 0 || this === null) {
                throw new TypeError('Array.prototype.indexOf called on null or undefined');
            }
            var k;
            var O = Object(this);
            var len = O.length >>> 0;
            if (len === 0) {
                return -1;
            }
            var n = fromIndex | 0;
            if (n >= len) {
                return -1;
            }
            k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);
            while (k < len) {
                if (k in O && O[k] === searchElement) {
                    return k;
                }
                k++;
            }
            return -1;
        }
    });
}

// from https://developer.mozilla.org/zh-CN/docs/Web/JavaScript/Reference/Global_Objects/Array/lastIndexOf
if (!Array.prototype.lastIndexOf) {
    Object.defineProperty(Array.prototype, "lastIndexOf", {
        value: function (searchElement) {
            if (this === void 0 || this === null) {
                throw new TypeError('Array.prototype.lastIndexOf called on null or undefined');
            }
            var n, k;
            var t = Object(this);
            var len = t.length >>> 0;
            if (len === 0) {
                return -1;
            }
            n = len - 1;
            if (arguments.length > 1) {
                n = Number(arguments[1]);
                if (n !== n) {
                    n = 0;
                } else if (n != 0 && n != (1 / 0) && n != -(1 / 0)) {
                    n = (n > 0 || -1) * Math.floor(Math.abs(n));
                }
            }
            k = n >= 0 ? Math.min(n, len - 1) : len - Math.abs(n);
            for (; k >= 0; k--) {
                if (k in t && t[k] === searchElement) {
                    return k;
                }
            }
            return -1;
        }
    });
}

// from https://developer.mozilla.org/zh-CN/docs/Web/JavaScript/Reference/Global_Objects/Array/map
if (!Array.prototype.map) {
    Object.defineProperty(Array.prototype, "map", {
        value: function (callback, thisArg) {
            if (this === void 0 || this === null) {
                throw new TypeError('Array.prototype.map called on null or undefined');
            }
            var T, A, k;
            var O = Object(this);
            var len = O.length >>> 0;
            if (Object.prototype.toString.call(callback) !== '[object Function]') {
                throw new TypeError(callback + ' is not a function');
            }
            if (thisArg) {
                T = thisArg;
            }
            A = new Array(len);
            k = 0;
            while (k < len) {
                var kValue, mappedValue;
                if (k in O) {
                    kValue = O[k];
                    mappedValue = callback.call(T, kValue, k, O);
                    A[k] = mappedValue;
                }
                k++;
            }
            return A;
        }
    });
}

// from https://developer.mozilla.org/zh-CN/docs/Web/JavaScript/Reference/Global_Objects/Array/Reduce
if (!Array.prototype.reduce) {
    Object.defineProperty(Array.prototype, "reduce", {
        value: function (callback) {
            if (this === void 0 || this === null) {
                throw new TypeError('Array.prototype.reduce called on null or undefined');
            }
            if (Object.prototype.toString.call(callback) !== '[object Function]') {
                throw new TypeError(callback + ' is not a function');
            }
            var t = Object(this), len = t.length >>> 0, k = 0, value;
            if (arguments.length >= 2) {
                value = arguments[1];
            } else {
                while (k < len && !(k in t)) {
                    k++;
                }
                if (k >= len) {
                    throw new TypeError('Reduce of empty array with no initial value');
                }
                value = t[k++];
            }
            for (; k < len; k++) {
                if (k in t) {
                    value = callback(value, t[k], k, t);
                }
            }
            return value;
        }
    })
}

// from https://developer.mozilla.org/zh-CN/docs/Web/JavaScript/Reference/Global_Objects/Array/ReduceRight
if (!Array.prototype.reduceRight) {
    Object.defineProperty(Array.prototype, "reduceRight", {
        value: function (callback) {
            if (this === void 0 || this === null) {
                throw new TypeError('Array.prototype.reduceRight called on null or undefined');
            }
            if (Object.prototype.toString.call(callback) !== '[object Function]') {
                throw new TypeError(callback + ' is not a function');
            }
            var t = Object(this), len = t.length >>> 0, k = len - 1, value;
            if (arguments.length >= 2) {
                value = arguments[1];
            } else {
                while (k >= 0 && !(k in t)) {
                    k--;
                }
                if (k < 0) {
                    throw new TypeError('Reduce of empty array with no initial value');
                }
                value = t[k--];
            }
            for (; k >= 0; k--) {
                if (k in t) {
                    value = callback(value, t[k], k, t);
                }
            }
            return value;
        }
    });
}

// from https://developer.mozilla.org/zh-CN/docs/Web/JavaScript/Reference/Global_Objects/Array/some
if (!Array.prototype.some) {
    Object.defineProperty(Array.prototype, "some", {
        value: function (callback) {
            if (this === void 0 || this === null) {
                throw new TypeError('Array.prototype.reduceRight called on null or undefined');
            }
            if (Object.prototype.toString.call(callback) !== '[object Function]') {
                throw new TypeError(callback + ' is not a function');
            }
            var t = Object(this);
            var len = t.length >>> 0;
            var thisArg = arguments.length >= 2 ? arguments[1] : void 0;
            for (var i = 0; i < len; i++) {
                if (i in t && callback.call(thisArg, t[i], i, t)) {
                    return true;
                }
            }
            return false;
        }
    })
}

if(!Array.from) {
	Array.from = (function() {
		var toStr = Object.prototype.toString;
		var isCallable = function(fn) {
			return typeof fn === 'function' || toStr.call(fn) === '[object Function]';
		};
		var toInteger = function(value) {
			var number = Number(value);
			if(isNaN(number)) {
				return 0;
			}
			if(number === 0 || !isFinite(number)) {
				return number;
			}
			return (number > 0?1:-1) * Math.floor(Math.abs(number));
		};
		var maxSafeInteger = Math.pow(2, 53) - 1;
		var toLength = function(value) {
			var len = toInteger(value);
			return Math.min(Math.max(len, 0), maxSafeInteger);
		};

		// The length property of the from method is 1.
		return function from(arrayLike/*, mapFn, thisArg */) {
			// 1. Let C be the this value.
			var C = this;

			// 2. Let items be ToObject(arrayLike).
			var items = Object(arrayLike);

			// 3. ReturnIfAbrupt(items).
			if(arrayLike == null) {
				throw new TypeError('Array.from requires an array-like object - not null or undefined');
			}

			// 4. If mapfn is undefined, then let mapping be false.
			var mapFn = arguments.length > 1?arguments[1]:void undefined;
			var T;
			if(typeof mapFn !== 'undefined') {
				// 5. else
				// 5. a If IsCallable(mapfn) is false, throw a TypeError exception.
				if(!isCallable(mapFn)) {
					throw new TypeError('Array.from: when provided, the second argument must be a function');
				}

				// 5. b. If thisArg was supplied, let T be thisArg; else let T be undefined.
				if(arguments.length > 2) {
					T = arguments[2];
				}
			}

			// 10. Let lenValue be Get(items, "length").
			// 11. Let len be ToLength(lenValue).
			var len = toLength(items.length);

			// 13. If IsConstructor(C) is true, then
			// 13. a. Let A be the result of calling the [[Construct]] internal method 
			// of C with an argument list containing the single item len.
			// 14. a. Else, Let A be ArrayCreate(len).
			var A = isCallable(C)?Object(new C(len)):new Array(len);

			// 16. Let k be 0.
			var k = 0;
			// 17. Repeat, while k < len… (also steps a - h)
			var kValue;
			while (k < len) {
				kValue = items[k];
				if(mapFn) {
					A[k] = typeof T === 'undefined'?mapFn(kValue, k):mapFn.call(T, kValue, k);
				} else {
					A[k] = kValue;
				}
				k += 1;
			}
			// 18. Let putStatus be Put(A, "length", len, true).
			A.length = len;
			// 20. Return A.
			return A;
		};
	}());
}

/**
 * Array.prototype.keys()
 * version 0.0.0
 * Feature	        Chrome  Firefox Internet Explorer   Opera	Safari	Edge
 * Basic support	  38      28      (No)    	          25    7.1     (Yes)
 * -------------------------------------------------------------------------------
 */
if (!Array.prototype.keys) {
    Object.defineProperty(Array.prototype, "keys", {
        value: function () {
            function Iterator() { }

            Iterator.prototype.next = function () {
                if (index > selfThis.length - 1) {
                    done = true;
                }
                if (done) {
                    return { value: undefined, done: true };
                }
                return { value: index++, done: false };
            };

            var selfThis = this;
            var index = 0;
            var done;

            return new Iterator();
        }
    });
}

// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/entries
if(!Array.prototype.entries) {
  Object.defineProperty(Array.prototype, "entries", {
    value: function() {
      function Iterator() { }

      Iterator.prototype.next = function() {
        if (index < selfThis.length) {
          return { value: [index, selfThis[index++]], done: false };
        } else {
          return { done: true };
        }
      }

      var selfThis = this;
      var index = 0;

      return new Iterator();
    }
  })
}

if (!Array.prototype.at) {
  Object.defineProperty(Array.prototype, "at", {
    value: function(n) {
      n = Math.trunc(n) || 0;

      if (n < 0) {
        n += this.length;
      }

      if (n < 0 || n >= this.length) {
        return undefined;
      }

      return this[n];
    }
  })
}

if(!Array.prototype.findIndex) {
	Object.defineProperty(Array.prototype, 'findIndex', {
		value: function(predicate) {
			// 1. Let O be ? ToObject(this value).
			if(this == null) {
				throw new TypeError('"this" is null or not defined');
			}

			var o = Object(this);

			// 2. Let len be ? ToLength(? Get(O, "length")).
			var len = o.length >>> 0;

			// 3. If IsCallable(predicate) is false, throw a TypeError exception.
			if(typeof predicate !== 'function') {
				throw new TypeError('predicate must be a function');
			}

			// 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
			var thisArg = arguments[1];

			// 5. Let k be 0.
			var k = 0;

			// 6. Repeat, while k < len
			while (k < len) {
				// a. Let Pk be ! ToString(k).
				// b. Let kValue be ? Get(O, Pk).
				// c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
				// d. If testResult is true, return k.
				var kValue = o[k];
				if(predicate.call(thisArg, kValue, k, o)) {
					return k;
				}
				// e. Increase k by 1.
				k++;
			}

			// 7. Return -1.
			return -1;
		},
		configurable: true,
		writable: true
	});
}

if(!Array.prototype.find) {
	Object.defineProperty(Array.prototype, 'find', {
		value: function(predicate) {
			// 1. Let O be ? ToObject(this value).
			if(this == null) {
				throw TypeError('"this" is null or not defined');
			}

			var o = Object(this);

			// 2. Let len be ? ToLength(? Get(O, "length")).
			var len = o.length >>> 0;

			// 3. If IsCallable(predicate) is false, throw a TypeError exception.
			if(typeof predicate !== 'function') {
				throw TypeError('predicate must be a function');
			}

			// 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
			var thisArg = arguments[1];

			// 5. Let k be 0.
			var k = 0;

			// 6. Repeat, while k < len
			while (k < len) {
				// a. Let Pk be ! ToString(k).
				// b. Let kValue be ? Get(O, Pk).
				// c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
				// d. If testResult is true, return kValue.
				var kValue = o[k];
				if(predicate.call(thisArg, kValue, k, o)) {
					return kValue;
				}
				// e. Increase k by 1.
				k++;
			}

			// 7. Return undefined.
			return undefined;
		},
		configurable: true,
		writable: true
	});
}


//https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/findLast
if (!Array.prototype.findLast) {
  Object.defineProperty(Array.prototype, 'findLast', {
    value: function findLast(callbackFn, thisArg) {

      if (this === void 0 || this === null) {
        throw new TypeError('Array.prototype.findLast called on null or undefined');
      }

      if (Object.prototype.toString.call(callbackFn) !== '[object Function]') {
        throw new TypeError(callbackFn + ' is not a function');
      }

			var arr = Object(this);
			var len = arr.length >>> 0;
			var k = len - 1;

			while (k >= 0) {
				var kValue = arr[k];
				if(callbackFn.call(thisArg, kValue, k, arr)) {
					return kValue;
				}
				k--;
			}

			return undefined;
    }
  });
}

//https://github.com/kevlatus/polyfill-array-includes/blob/master/array-includes.js
if (!Array.prototype.includes) {
  Object.defineProperty(Array.prototype, 'includes', {
    value: function (searchElement, fromIndex) {

      // 1. Let O be ? ToObject(this value).
      if (this == null) {
        throw new TypeError('"this" is null or not defined');
      }

      var o = Object(this);

      // 2. Let len be ? ToLength(? Get(O, "length")).
      var len = o.length >>> 0;

      // 3. If len is 0, return false.
      if (len === 0) {
        return false;
      }

      // 4. Let n be ? ToInteger(fromIndex).
      //    (If fromIndex is undefined, this step produces the value 0.)
      var n = fromIndex | 0;

      // 5. If n ≥ 0, then
      //  a. Let k be n.
      // 6. Else n < 0,
      //  a. Let k be len + n.
      //  b. If k < 0, let k be 0.
      var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

      function sameValueZero(x, y) {
        return x === y || (typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y));
      }

      // 7. Repeat, while k < len
      while (k < len) {
        // a. Let elementK be the result of ? Get(O, ! ToString(k)).
        // b. If SameValueZero(searchElement, elementK) is true, return true.
        // c. Increase k by 1.
        if (sameValueZero(o[k], searchElement)) {
          return true;
        }
        k++;
      }

      // 8. Return false
      return false;
    }
  });
}
// https://dev.to/chandrapenugonda/polyfill-arrayflat-3ipb
if (!Array.prototype.flat) {
  Object.defineProperty(Array.prototype, "flat", {
    value: function(depth) {
      var flattened = [];

      function flatten(arr, currentDepth) {
        for (var i = 0; i < arr.length; i++) {
          if (Array.isArray(arr[i]) && currentDepth < depth) {
            flatten(arr[i], currentDepth + 1);
          } else {
            flattened.push(arr[i]);
          }
        }
      }

      flatten(this, 0);

      return flattened;
    }
  })
}
if (!Array.prototype.flatMap) {
	Object.defineProperty(Array.prototype, "flatMap", {
        value: function() {
            return Array.prototype.map.apply(this, arguments).flat();
        }
	})
}
// https://12daysofweb.dev/2023/new-js-array-methods/
if (!Array.prototype.toReversed) {
    Object.defineProperty(Array.prototype, "toReversed", {
        value: function () {
            return Array.from(this).reverse();
        }
    })
}
if (!Array.prototype.toSpliced) {
    Object.defineProperty(Array.prototype, "toSpliced", {
        value: function (start, end) {
            var clone = Array.from(this);
            clone.splice(start, end);
            return clone;
        }
    })
}
if (!Array.prototype.toSorted) {
    Object.defineProperty(Array.prototype, "toSorted", {
        value: function (compareFn) {
            return Array.from(this).sort(compareFn);
        }
    })
}
if (!Array.prototype["with"]) {
    Object.defineProperty(Array.prototype, "with", {
        value: function (index, value) {
            var clone = Array.from(this);
            clone[index] = value;
            return clone;
        }
    })
}
//----------------------------------------------------------------------
//
// CSSOM View Module
// https://dev.w3.org/csswg/cssom-view/
//
//----------------------------------------------------------------------

// Fix for IE8-'s Element.getBoundingClientRect()
(function (global) {
  if ('TextRectangle' in global && !('width' in global.TextRectangle.prototype)) {
    Object.defineProperties(global.TextRectangle.prototype, {
      'width': { get: function () { return this.right - this.left; } },
      'height': { get: function () { return this.bottom - this.top; } }
    });
  }
})(window);
/**
 * polyfill for Date
 */

// from https://developer.mozilla.org/en/Core_JavaScript_1.5_Reference/Global_Objects/Date/now
if (!Date.now) {
  Date.now = function now () {
    return new Date().getTime();
  };
}

// from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toISOString
if (!Date.prototype.toISOString) {
  (function() {
    function pad(number) {
      if (number < 10) {
        return '0' + number;
      }
      return number;
    }
    Date.prototype.toISOString = function () {
      return this.getUTCFullYear() +
        '-' + pad(this.getUTCMonth() + 1) +
        '-' + pad(this.getUTCDate()) +
        'T' + pad(this.getUTCHours()) +
        ':' + pad(this.getUTCMinutes()) +
        ':' + pad(this.getUTCSeconds()) +
        '.' + (this.getUTCMilliseconds() / 1000).toFixed(3).slice(2, 5) +
        'Z';
    };
  }());
}
/**
 * polyfill for DOM
 */

(function (global) {
  if (!('document' in global)) {
    return;
  }
  var document = global.document;

  // IE8- document.getElementsByClassName
  if (!document.getElementsByClassName && document.querySelectorAll) {
    var getElementsByClassName = function (classNames) {
      classNames = String(classNames).replace(/^|\s+/g, '.');
      return this.querySelectorAll(classNames);
    };
    void [HTMLDocument, Element].forEach(function (o) {
      o.prototype.getElementsByClassName = getElementsByClassName;
    });
  }

  // IE CustomEvent
  if (!('CustomEvent' in global) || typeof global.CustomEvent !== 'function') {
    var CustomEvent = function (event, params) {
      params = params || { bubbles: false, cancelable: false, detail: undefined };
      var evt = document.createEvent('CustomEvent');
      evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
      return evt;
    };
    CustomEvent.prototype = global.Event.prototype;
    global.CustomEvent = CustomEvent;
  }

  var NativeProgressEvent = global.ProgressEvent;
  var useNative = !!NativeProgressEvent;

  try {
      (function () {
          var p = new NativeProgressEvent('loaded');
          useNative = 'loaded' === p.type;
          p = null;
      })();
  } catch (e) {
      useNative = false;
  }

  /**
   * Cross-browser `ProgressEvent` constructor.
   *
   * https://developer.mozilla.org/en-US/docs/Web/API/ProgressEvent.ProgressEvent
   *
   * @public
   */
  if(!useNative){
      global.ProgressEvent = // IE >= 9
          'function' === typeof document.createEvent ? function (type, props) {
              var e = document.createEvent('Event');
              e.initEvent(type, false, false);
              if (props) {
                  e.lengthComputable = Boolean(props.lengthComputable);
                  e.loaded = Number(props.loaded) || 0;
                  e.total = Number(props.total) || 0;
              } else {
                  e.lengthComputable = false;
                  e.loaded = e.total = 0;
              }
              return e;
          } :

  // IE <= 8
          function (type, props) {
              var e = document.createEventObject();
              e.type = type;
              if (props) {
                  e.lengthComputable = Boolean(props.lengthComputable);
                  e.loaded = Number(props.loaded) || 0;
                  e.total = Number(props.total) || 0;
              } else {
                  e.lengthComputable = false;
                  e.loaded = e.total = 0;
              }
              return e;
          };
  }

  // Element.matches
  // from https://developer.mozilla.org/en/docs/Web/API/Element/matches
  (function () {
    if (!('Element' in global) || Element.prototype.matches) {
      return;
    }
    var matchesVenders = ['ms', 'o', 'moz', 'webkit'];
    var matchesSelectorSuffix = 'MatchesSelector';
    for (var i = 0; i < matchesVenders.length; i++) {
      var matchesSelector = matchesVenders[i] + matchesSelectorSuffix;
      if (matchesSelector in Element.prototype) {
        Element.prototype.matches = Element.prototype[matchesSelector];
        return;
      }
    }
    if (document.querySelectorAll) {
      Element.prototype.matches = function matches (selector) {
        var matches = (this.document || this.ownerDocument).querySelectorAll(selector);
        var i = matches.length;
        while (--i >= 0 && matches.item(i) !== this) {}
        return i > -1;
      };
    }
  })();

  if (!document.querySelector) {
    document.querySelector = function (selectors) {
      var elements = document.querySelectorAll(selectors);
      return (elements.length) ? elements[0] : null;
    };
  }

  // Node.textContent
  if (Object.defineProperty
    && Object.getOwnPropertyDescriptor
    && Object.getOwnPropertyDescriptor(Element.prototype, 'textContent')
    && !Object.getOwnPropertyDescriptor(Element.prototype, 'textContent').get) {
    (function() {
      var innerText = Object.getOwnPropertyDescriptor(Element.prototype, 'innerText');
      Object.defineProperty(Element.prototype, 'textContent', {
        get: function() {
          return innerText.get.call(this);
        },
        set: function(s) {
          innerText.set.call(this, s);
        }
      });
    })();
  }
})(window);

/**
 * polyfill for DOM Event
 */

// from https://github.com/Financial-Times/polyfill-service/blob/master/polyfills/Event/polyfill.js
(function (global) {
  if (('Event' in global) && typeof global.Event === 'function') {
    return;
  }
  var unlistenableWindowEvents = {
    click: 1,
    dblclick: 1,
    keyup: 1,
    keypress: 1,
    keydown: 1,
    mousedown: 1,
    mouseup: 1,
    mousemove: 1,
    mouseover: 1,
    mouseenter: 1,
    mouseleave: 1,
    mouseout: 1,
    storage: 1,
    storagecommit: 1,
    textinput: 1
  };
  var existingProto = (global.Event && global.Event.prototype) || null;
  global.Event = Window.prototype.Event = function Event (type, eventInitDict) {
    if (!type) {
      throw new Error('Not enough arguments');
    }
    var event;
    if ('createEvent' in document) {
      event = document.createEvent('Event');
      var bubbles = eventInitDict && eventInitDict.bubbles !== undefined ? eventInitDict.bubbles : false;
      var cancelable = eventInitDict && eventInitDict.cancelable !== undefined ? eventInitDict.cancelable : false;
      event.initEvent(type, bubbles, cancelable);
      return event;
    }
    event = document.createEventObject();
    event.type = type;
    event.bubbles = eventInitDict && eventInitDict.bubbles !== undefined ? eventInitDict.bubbles : false;
    event.cancelable = eventInitDict && eventInitDict.cancelable !== undefined ? eventInitDict.cancelable : false;
    return event;
  };
  if (existingProto) {
    Object.defineProperty(global.Event, 'prototype', {
      configurable: false,
      enumerable: false,
      writable: true,
      value: existingProto
    });
  }
  if (!('createEvent' in document)) {
    var addEventListener = function (type, listener) {
      var element = this;
      if (element === global && type in unlistenableWindowEvents) {
        throw new Error('In IE8 the event: ' + type + ' is not available on the window object.');
      }
      if (!element._events) {
        element._events = {};
      }
      if (!element._events[type]) {
        element._events[type] = function (event) {
          var list = element._events[event.type].list;
          var events = list.slice();
          var index = -1;
          var length = events.length;
          var eventElement;
          event.preventDefault = function preventDefault () {
            if (event.cancelable !== false) {
              event.returnValue = false;
            }
          };
          event.stopPropagation = function stopPropagation () {
            event.cancelBubble = true;
          };
          event.stopImmediatePropagation = function stopImmediatePropagation () {
            event.cancelBubble = true;
            event.cancelImmediate = true;
          };
          event.currentTarget = element;
          event.target = event.target || event.srcElement || element;
          event.relatedTarget = event.fromElement ? (event.fromElement === event.target) ? event.toElement : event.fromElement : null;
          event.timeStamp = new Date().getTime();
          if (event.clientX) {
            event.pageX = event.clientX + document.documentElement.scrollLeft;
            event.pageY = event.clientY + document.documentElement.scrollTop;
          }
          while (++index < length && !event.cancelImmediate) {
            if (index in events) {
              eventElement = events[index];
              if (list.indexOf(eventElement) !== -1 && typeof eventElement === 'function') {
                eventElement.call(element, event);
              }
            }
          }
        };
        element._events[type].list = [];
        if (element.attachEvent) {
          element.attachEvent('on' + type, element._events[type]);
        }
      }
      element._events[type].list.push(listener);
    };

    var removeEventListener = function (type, listener) {
      var element = this;
      var index;
      if (element._events && element._events[type] && element._events[type].list) {
        index = element._events[type].list.indexOf(listener);
        if (index !== -1) {
          element._events[type].list.splice(index, 1);
          if (!element._events[type].list.length) {
            if (element.detachEvent) {
              element.detachEvent('on' + type, element._events[type]);
            }
            delete element._events[type];
          }
        }
      }
    };

    var dispatchEvent = function (event) {
      if (!arguments.length) {
        throw new Error('Not enough arguments');
      }
      if (!event || typeof event.type !== 'string') {
        throw new Error('DOM Events Exception 0');
      }
      var element = this, type = event.type;
      try {
        if (!event.bubbles) {
          event.cancelBubble = true;
          var cancelBubbleEvent = function (event) {
            event.cancelBubble = true;
            (element || window).detachEvent('on' + type, cancelBubbleEvent);
          };
          this.attachEvent('on' + type, cancelBubbleEvent);
        }
        this.fireEvent('on' + type, event);
      } catch (error) {
        event.target = element;
        do {
          event.currentTarget = element;
          if ('_events' in element && typeof element._events[type] === 'function') {
            element._events[type].call(element, event);
          }
          if (typeof element['on' + type] === 'function') {
            element['on' + type].call(element, event);
          }
          element = element.nodeType === 9 ? element.parentWindow : element.parentNode;
        } while (element && !event.cancelBubble);
      }
      return true;
    };

    void [Window, HTMLDocument, Element].forEach(function (o) {
      o.prototype.addEventListener = addEventListener;
      o.prototype.removeEventListener = removeEventListener;
      o.prototype.dispatchEvent = dispatchEvent;
    });

    // 添加DOMContentLoaded事件
    document.attachEvent('onreadystatechange', function() {
      if (document.readyState === 'complete') {
        document.dispatchEvent(new Event('DOMContentLoaded', {
          bubbles: true
        }));
      }
    });
  }
})(window);

/*
 * Node.isConnected polyfill for EdgeHTML
 * 2021-04-12
 *
 * By Eli Grey, https://eligrey.com
 * Public domain.
 * NO WARRANTY EXPRESSED OR IMPLIED. USE AT YOUR OWN RISK.
 */

if (!('isConnected' in Node.prototype)) {
  Object.defineProperty(Node.prototype, 'isConnected', {
    get: function() {
      return (
        !this.ownerDocument ||
        !(
          this.ownerDocument.compareDocumentPosition(this) &
          this.DOCUMENT_POSITION_DISCONNECTED
        )
      );
    }
  });
}

/**
 * polyfill for getComputedStyle
 */

// from https://github.com/Financial-Times/polyfill-service/blob/master/polyfills/getComputedStyle/polyfill.js
(function (global) {
  if ('getComputedStyle' in global && typeof global.getComputedStyle === 'function') {
    return;
  }
  function getPixelSize (element, style, property, fontSize) {
    var sizeWithSuffix = style[property];
    var size = parseFloat(sizeWithSuffix);
    var suffix = sizeWithSuffix.split(/\d/)[0];
    var rootSize;
    fontSize = (fontSize !== null) ? fontSize :
      (/%|em/.test(suffix) && element.parentElement) ?
        getPixelSize(element.parentElement, element.parentElement.currentStyle, 'fontSize', null) : 16;
    rootSize = property === 'fontSize' ? fontSize :
      /width/i.test(property) ? element.clientWidth : element.clientHeight;
    return (suffix ==='em') ? size * fontSize :
      (suffix === 'in') ? size * 96 :
        (suffix === 'pt') ? size * 96 / 72 :
          (suffix === '%') ? size / 100 * rootSize : size;
  }

  function setShortStyleProperty (style, property) {
    var borderSuffix = property === 'border' ? 'Width' : '';
    var t = property + 'Top' + borderSuffix;
    var r = property + 'Right' + borderSuffix;
    var b = property + 'Bottom' + borderSuffix;
    var l = property + 'Left' + borderSuffix;
    style[property] = (style[t] == style[r] == style[b] == style[l] ? [style[t]]
      : style[t] == style[b] && style[l] == style[r] ? [style[t], style[r]]
      : style[l] == style[r] ? [style[t], style[r], style[b]]
      : [style[t], style[r], style[b], style[l]]).join(' ');
  }

  function CSSStyleDeclaration (element) {
    var currentStyle = element.currentStyle || {};
    var style = this;
    var fontSize = getPixelSize(element, currentStyle, 'fontSize', null);
    for (var property in currentStyle) {
      if (/width|height|margin.|padding.|border.+W/.test(property) && style[property] !== 'auto') {
        style[property] = getPixelSize(element, currentStyle, property, fontSize) + 'px';
      } else if (property === 'styleFloat') {
        style['float'] = currentStyle[property];
      } else {
        style[property] = currentStyle[property];
      }
    }
    setShortStyleProperty(style, 'margin');
    setShortStyleProperty(style, 'padding');
    setShortStyleProperty(style, 'border');
    style.fontSize = fontSize + 'px';
    return style;
  }

  CSSStyleDeclaration.prototype = {
    constructor: CSSStyleDeclaration,
    getPropertyPriority: function () { },
    getPropertyValue: function (prop) {
      return this[prop] || '';
    },
    item: function () { },
    removeProperty: function () { },
    setProperty: function () { },
    getPropertyCSSValue: function () { }
  };
  global.getComputedStyle = function (node) {
    return new CSSStyleDeclaration(node);
  };
})(window);

// polyfill for :scope
try {
	// test for scope support
	document.querySelector(':scope *');
} catch (error) {
	(function (ElementPrototype) {
		// scope regex
		var scope = /:scope(?![\w-])/gi;

		// polyfill Element#querySelector
		var querySelectorWithScope = polyfill(ElementPrototype.querySelector);

		ElementPrototype.querySelector = function querySelector(selectors) {
			return querySelectorWithScope.apply(this, arguments);
		};

		// polyfill Element#querySelectorAll
		var querySelectorAllWithScope = polyfill(ElementPrototype.querySelectorAll);

		ElementPrototype.querySelectorAll = function querySelectorAll(selectors) {
			return querySelectorAllWithScope.apply(this, arguments);
		};

		// polyfill Element#matches
		if (ElementPrototype.matches) {
			var matchesWithScope = polyfill(ElementPrototype.matches);

			ElementPrototype.matches = function matches(selectors) {
				return matchesWithScope.apply(this, arguments);
			};
		}

		// polyfill Element#closest
		if (ElementPrototype.closest) {
			var closestWithScope = polyfill(ElementPrototype.closest);

			ElementPrototype.closest = function closest(selectors) {
				return closestWithScope.apply(this, arguments);
			};
		}

		function polyfill(qsa) {
			return function (selectors) {
				// whether the selectors contain :scope
				var hasScope = selectors && scope.test(selectors);

				if (hasScope) {
					// fallback attribute
					var attr = 'q' + Math.floor(Math.random() * 9000000) + 1000000;

					// replace :scope with the fallback attribute
					arguments[0] = selectors.replace(scope, '[' + attr + ']');

					// add the fallback attribute
					this.setAttribute(attr, '');

					// results of the qsa
					var elementOrNodeList = qsa.apply(this, arguments);

					// remove the fallback attribute
					this.removeAttribute(attr);

					// return the results of the qsa
					return elementOrNodeList;
				} else {
					// return the results of the qsa
					return qsa.apply(this, arguments);
				}
			};
		}
	})(Element.prototype);
}
/**
 * polyfill for IE8 in HTML
 * https://html.spec.whatwg.org
 */

// document.head
try {
document.head = document.head || document.getElementsByTagName('head')[0];
} catch(e) {}

// HTML Tag shiv
void [
  'abbr', 'article', 'aside', 'audio', 'bdi', 'canvas', 'data', 'datalist',
  'details', 'dialog', 'figcaption', 'figure', 'footer', 'header', 'hgroup',
  'main', 'mark', 'meter', 'nav', 'output', 'picture', 'progress', 'section',
  'summary', 'template', 'time', 'video'
].forEach(function (tag) {
  document.createElement(tag);
});
/**
 * polyfill for String
 */

if (!String.prototype.trim) {
  String.prototype.trim = function () {
    return String(this).replace(/^\s+/, '').replace(/\s+$/, '');
  };
}

// endsWiths
if (!String.prototype.endsWith) {
	String.prototype.endsWith = function(search, this_len) {
		if (this_len === undefined || this_len > this.length) {
			this_len = this.length;
		}
		return this.substring(this_len - search.length, this_len) === search;
	};
}
// startsWith
if (!String.prototype.startsWith) {
	String.prototype.startsWith = function(search, pos) {
		return this.substring(!pos || pos < 0 ? 0 : +pos, search.length) === search;
	};
}
//https://github.com/FabioVergani/js-Polyfill_String-trimStart
(function(o,p){
    if(p in o?o[p]?false:true:true){
        var r=/^\s+/;
        o[p]=o.trimLeft||function(){
            return this.replace(r,'')
        }
    }
})(window.String.prototype,'trimStart');
// trim end
if (!String.prototype.trimEnd) {
	String.prototype.trimEnd = function () {
		return this.replace(new RegExp(/[\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF]+/.source + '$', 'g'), '');
	};
}
// repeat
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/repeat
if (!String.prototype.repeat) {
  String.prototype.repeat = function(count) {
    'use strict';
    if (this == null)
      {throw new TypeError('can\'t convert ' + this + ' to object');}

    var str = '' + this;
    // To convert string to integer.
    count = +count;
    // Check NaN
    if (count != count)
      {count = 0;}

    if (count < 0)
      {throw new RangeError('repeat count must be non-negative');}

    if (count == Infinity)
      {throw new RangeError('repeat count must be less than infinity');}

    count = Math.floor(count);
    if (str.length == 0 || count == 0)
      {return '';}

    // Ensuring count is a 31-bit integer allows us to heavily optimize the
    // main part. But anyway, most current (August 2014) browsers can't handle
    // strings 1 << 28 chars or longer, so:
    if (str.length * count >= 1 << 28)
      {throw new RangeError('repeat count must not overflow maximum string size');}

    var maxCount = str.length * count;
    count = Math.floor(Math.log(count) / Math.log(2));
    while (count) {
       str += str;
       count--;
    }
    str += str.substring(0, maxCount - str.length);
    return str;
  }
}
// https://github.com/behnammodi/polyfill/blob/master/string.polyfill.js
if (!String.prototype.padStart) {
  Object.defineProperty(String.prototype, 'padStart', {
    configurable: true,
    writable: true,
    value: function (targetLength, padString) {
      targetLength = targetLength >> 0; //floor if number or convert non-number to 0;
      padString = String(typeof padString !== 'undefined' ? padString : ' ');
      if (this.length > targetLength) {
        return String(this);
      } else {
        targetLength = targetLength - this.length;
        if (targetLength > padString.length) {
          padString += padString.repeat(targetLength / padString.length); //append to original to ensure we are longer than needed
        }
        return padString.slice(0, targetLength) + String(this);
      }
    }
  });
}
// https://github.com/behnammodi/polyfill/blob/master/string.polyfill.js
if (!String.prototype.padEnd) {
  Object.defineProperty(String.prototype, 'padEnd', {
    configurable: true,
    writable: true,
    value: function (targetLength, padString) {
      targetLength = targetLength >> 0; //floor if number or convert non-number to 0;
      padString = String(typeof padString !== 'undefined' ? padString : ' ');
      if (this.length > targetLength) {
        return String(this);
      } else {
        targetLength = targetLength - this.length;
        if (targetLength > padString.length) {
          padString += padString.repeat(targetLength / padString.length); //append to original to ensure we are longer than needed
        }
        return String(this) + padString.slice(0, targetLength);
      }
    }
  });
}

if (!String.prototype.includes) {
  String.prototype.includes = function(search, start) {
    'use strict';

    if (search instanceof RegExp) {
      throw TypeError('first argument must not be a RegExp');
    }
    if (start === undefined) { start = 0; }
    return this.indexOf(search, start) !== -1;
  };
}

/**
 * Polyfill for Viewport
 */

(function (global) {
  if ('innerWidth' in global && 'innerHeight' in global && 'pageXOffset' in global && 'pageYOffset' in global) {
    return;
  }
  var doc = global.document;
  var docEl = doc.documentElement;
  var body = doc.body || doc.createElement('body');

  function scrollX () {
    return (docEl.scrollLeft || body.scrollLeft || 0) - (docEl.clientLeft || body.clientLeft || 0);
  }

  function scrollY () {
    return (docEl.scrollTop || body.scrollTop || 0) - (docEl.clientTop || body.clientTop || 0);
  }

  Object.defineProperties(global, {
    innerWidth: {
      get: function () {
        return docEl.clientWidth;
      }
    },
    innerHeight: {
      get: function () {
        return docEl.clientHeight;
      }
    },
    pageXOffset: {
      get: scrollX
    },
    pageYOffset: {
      get: scrollY
    },
    scrollX: {
      get: scrollX
    },
    scrollY: {
      get: scrollY
    }
  });
})(window);

/**
 * Polyfill for Math
 */
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/log10
Math.log10 = Math.log10 || function(x) {
  return Math.log(x) * Math.LOG10E;
};

/**
 * Polyfill Set
 */
// IE11 has an incomplete implementation of Set which doesn't allow you to iterate the keys
// so this code assumes you want a full implementation and will redefine Set if the half
// implementation is present
if (typeof Set === "undefined" || typeof Set.prototype.keys !== "function") {
  var Set = (function() {
      "use strict";
      
      var iterables = {
          "[object Array]": true,
          "[object Arguments]": true,
          "[object HTMLCollection]": true,
          "[object NodeList]": true
      };
      
      // shortcuts
      var hasOwn = Object.prototype.hasOwnProperty;
      var toString = Object.prototype.toString;
      
      function hasOwnProp(obj, prop) {
          return hasOwn.call(obj, prop);
      }
      
      function isIterable(item) {
          // for purposes of this implementation, an iterable is anything we can iterate with
          // a classic for loop:
          //     for (var i = 0; i < item.length; i++)
          // Currently accepts: array, arguments object, HTMLCollection, NodeList
          // and anything that has a .length with a numeric value and, if .length > 0, the first item has a nodeType property
          var name;
          if (typeof item === "object") {
              name = toString.call(item);
              return ((iterables[name] === true) || 
                  (typeof item.length === "number" && 
                      item.length >= 0 && 
                      (item.length === 0 || (typeof item[0] === "object" && item[0].nodeType > 0))
                  )
              );
          }
          return false;
      }

      // decide if we can use Object.defineProperty
      // include a test for Object.defineProperties (which IE8 does not have) to eliminate
      // using the broken Object.defineProperty in IE8
      var canDefineProperty = Object.defineProperty && Object.defineProperties;
      
      function setProperty(obj, propName, value, enumerable, writable) {
          if (canDefineProperty) {
              Object.defineProperty(obj, propName, {
                  enumerable: enumerable,
                  configurable: false,
                  writable: writable,
                  value: value
              });
          } else {
              obj[propName] = value;
          }
      }
      
      // this private function is used like a private method for setting
      // the .size property.  It cannot be called from outside this closure.
      var settable = false;
      function setSize(obj, val) {
          settable = true;
          obj.size = val;
          settable = false;
      }

      // this is the constructor function which will be returned
      // from this closure
      function SetConstructor(arg) {
          // private member variable, not used if IE8
          var size = 0;
          
          // set properties in cross-browser way
          setProperty(this, "baseType", "Set", false, false);   // not enumerable, not writeable
          setProperty(this, "_data", {}, false, true);          // not enumerable, writeable
          if (canDefineProperty) {
              Object.defineProperty(this, "size", {
                  enumerable: true,
                  configurable: false,
                  get: function() { return size;},
                  set: function(val) {
                      if (!settable) {throw new Error("Can't set size property on Set object.")}
                      size = val;
                  }
              });
          } else {
              // .size is just regular property in IE8
              this.size = 0;
          }
          // now add initial data
          // per spec make sure it isn't undefined or null
          if (arg !== undefined && arg !== null) {
              if (isIterable(arg)) {
                  for (var i = 0; i < arg.length; i++) {
                      this.add(arg[i]);
                  }
              // also check our own custom property in case
              // there is cross window code that won't pass instanceof
              } else if (arg instanceof Set || arg.baseType === "Set") {
                  arg.forEach(function(item) {
                      this.add(item);
                  }, this);
              }
          }
      }

      // state variables and shared constants
      var objectCntr = 0;
      var objectCntrBase = "obj_";
      var objectCntrProp = "__objectPolyFillID";
      
      // types where we just use the first 3 letters of the type
      // plus underscore + toString() to make the key
      // The first 3 letters of the type makes a namespace for each
      // type so we can have things like 0 and "0" as separate keys
      // "num_0" and "str_0".
      var autoTypes = {
          "string": true,
          "boolean": true,
          "number": true,
          "undefined": true
      };
      
      function getKey(val, putKeyOnObject) {
          // manufacture a namespaced key
          var type = typeof val, id;
          if (autoTypes[type]) {
              return type.substring(0, 3) + "_" + val;
          } else if (val === null) {
              return "nul_null";
          } else if (type === "object" || type === "function") {
              // coin a unique id for each object and store it on the object
              if (val[objectCntrProp]) {
                  return val[objectCntrProp];
              } else if (!putKeyOnObject) {
                  // it only returns null if there is no key already on the object
                  // and it wasn't requested to create a new key on the object
                  return null;
              } else {
                  // coin a unique id for the object
                  id = objectCntrBase + objectCntr++;
                  // include a test for Object.defineProperties to rule out IE8 
                  // which can't use Object.defineProperty on normal JS objects
                  if (toString.call(val) === "[object Object]" && canDefineProperty) {
                      Object.defineProperty(val, objectCntrProp, {
                          enumerable: false,
                          configurable: false,
                          writable: false,
                          value: id
                      });
                  } else {
                      // no Object.defineProperty() or not plain object, so just assign property directly
                      val[objectCntrProp] = id;
                  }
                  return id;
              }
          } else {
              throw new Error("Unsupported type for Set.add()");
          }
      }
      
      function SetIterator(keys, data, format) {
          var index = 0, len = keys.length;
          this.next = function() {
              var val, result = {}, key;
              while (true) {
                  if (index < len) {
                      result.done = false;
                      key = keys[index++];
                      val = data[key];
                      // check to see if key might have been removed
                      // undefined is a valid value in the set so we have to check more than that
                      // if it is no longer in the set, get the next key
                      if (val === undefined && !hasOwnProp(data, key)) {
                          continue;
                      }
                      if (format === "keys") {
                          result.value = val;
                      } else if (format === "entries") {
                          result.value = [val, val];
                      }
                  } else {
                      // clear references to outside data
                      keys = null;
                      data = null;
                      result.done = true;
                  }
                  return result;
              }
          };
      }
      
      function getKeys(data) {
          var keys = [];
          for (var prop in data) {
              if (hasOwnProp(data, prop)) {
                  keys.push(prop);
              }
          }
          return keys;
      }
      
      SetConstructor.prototype = {
          add: function(val) {
              var key = getKey(val, true);
              if (!hasOwnProp(this._data, key)) {
                  this._data[key] = val;
                  setSize(this, this.size + 1);
              }
              return this;
          },
          clear: function() {
              this._data = {};
              setSize(this, 0);
          },
          // delete has to be in quotes for IE8 - go figure
          "delete": function(val) {
              var key = getKey(val, false);
              if (key !== null && hasOwnProp(this._data, key)) {
                  delete this._data[key];
                  setSize(this, this.size - 1);
                  return true;
              }
              return false;
          },
          // .remove() is non-standard, but here for anyone who wants to use it
          // so that you can use this polyfill all the way down to IE7 and IE8
          // since IE8 can't use a method named .delete()
          remove: function(val) {
              return this["delete"](val);
          },
          forEach: function(fn /*, context */) {
              // by spec, we have to type check the fn argument
              if (typeof fn !== "function") {return;}
              
              // context argument is optional, but .forEach.length is supposed to be 1 by spec
              // so we declare it this way
              var context = arguments[1];
              
              // forEach specifies that the iteration set is
              // determined before the first callback so we get all the
              // keys first
              var iter = this.keys(), next, item;
              while ((next = iter.next()) && !next.done) {
                  item = next.value;
                  fn.call(context, item, item, this);
              }
          },
          has: function(val) {
              var key = getKey(val, false);
              if (key === null) {return false;}
              return hasOwn.call(this._data, key);
          },
          values: function() {
              return this.keys();
          },
          keys: function() {
              return new SetIterator(getKeys(this._data), this._data, "keys");
          },
          entries: function() {
              return new SetIterator(getKeys(this._data), this._data, "entries");
          }
      };
          
      SetConstructor.prototype.constructor = SetConstructor;    
      
      return SetConstructor;
  })();
}

if (!Set.prototype.difference) {
    Set.prototype.difference = function (other) {
        if (other === null || typeof other !== "object") {
            throw new TypeError("Set.prototype.difference argument must be an object");
        }
        if (typeof other.size !== "number") {
            throw new TypeError("The .size property is NaN");
        }
        var result = new Set();
        this.forEach(function(item){
            if (!other.has(item)) {
                result.add(item);
            }
        })
        return result;
    }
}
if (!Set.prototype.intersection) {
    Set.prototype.intersection = function (other) {
        if (other === null || typeof other !== "object") {
            throw new TypeError("Set.prototype.intersection argument must be an object");
        }
        if (typeof other.size !== "number") {
            throw new TypeError("The .size property is NaN");
        }
        var result = new Set();
        this.forEach(function(item){
            if (other.has(item)) {
                result.add(item);
            }
        })
        return result;
    }
}
if (!Set.prototype.symmetricDifference) {
    Set.prototype.symmetricDifference = function (other) {
        if (other === null || typeof other !== "object") {
            throw new TypeError("Set.prototype.symmetricDifference argument must be an object");
        }
        if (typeof other.size !== "number") {
            throw new TypeError("The .size property is NaN");
        }
        var result = new Set(this);
        var entries = other.keys();
        var iterator = entries.next();
        while(!iterator.done) {
            if (result.has(iterator.value)) {
                result.delete(iterator.value);
            } else {
                result.add(iterator.value);
            }
            iterator = entries.next();
        }
        return result;
    }
}
if (!Set.prototype.union) {
    Set.prototype.union = function (other) {
        if (other === null || typeof other !== "object") {
            throw new TypeError("Set.prototype.union argument must be an object");
        }
        if (typeof other.size !== "number") {
            throw new TypeError("The .size property is NaN");
        }
        var result = new Set(this);
        var entries = other.keys();
        var iterator = entries.next();
        while(!iterator.done) {
            result.add(iterator.value);
            iterator = entries.next();
        }
        return result;
    }
}
if (!Set.prototype.isDisjointFrom) {
    Set.prototype.isDisjointFrom = function (other) {
        if (other === null || typeof other !== "object") {
            throw new TypeError("Set.prototype.isDisjointFrom argument must be an object");
        }
        if (typeof other.size !== "number") {
            throw new TypeError("The .size property is NaN");
        }
        this.forEach(function(item){
            if (other.has(item)) {
                return false;
            }
        })
        return true;
    }
}
if (!Set.prototype.isSubsetOf) {
    Set.prototype.isSubsetOf = function (other) {
        if (other === null || typeof other !== "object") {
            throw new TypeError("Set.prototype.isSubsetOf argument must be an object");
        }
        if (typeof other.size !== "number") {
            throw new TypeError("The .size property is NaN");
        }
        this.forEach(function(item){
            if (other.has(item) === false) {
                return false;
            }
        })
        return true;
    }
}
if (!Set.prototype.isSupersetOf) {
    Set.prototype.isSupersetOf = function (other) {
        if (other === null || typeof other !== "object") {
            throw new TypeError("Set.prototype.isSupersetOf argument must be an object");
        }
        if (typeof other.size !== "number") {
            throw new TypeError("The .size property is NaN");
        }
        var entries = other.keys();
        var iterator = entries.next();
        while(!iterator.done) {
            if (this.has(iterator.value) === false) {
                return false;
            }
            iterator = entries.next();
        }
        return true;
    }
}

/**
 * Polyfill for WeakMap
 */
if(typeof WeakMap !== 'function') {
	var mUIDs = [];
	
	
	window.WeakMap = function() {
		this.map = {};
		this.length = 0;
	}
	
	WeakMap.prototype = {
		constructor: WeakMap,

    _generateUID: function() {
      function s4() {
        return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
      }
      do {
        var guid = s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
      } while(mUIDs.indexOf(guid) !== -1);
      mUIDs.push(guid);
      return guid;
    },

		set: function(key, value) {
			if(key.__WeakMapKey === undefined) {
				key.__WeakMapKey = this._generateUID();
			}
			
			if(this.map[key.__WeakMapKey] === undefined) {
				this.length++;
				
				if(this.length > 100000) {
					throw new Error("WeakMap overload! Get a better browser!");
				}
			}
			
			this.map[key.__WeakMapKey] = value;
			
			return this;
		},
		
		get: function(key) {
			if(key.__WeakMapKey === undefined) {
				return undefined;
			}
			
			return this.map[key.__WeakMapKey];
		},
		// delete has to be in quotes for IE8 - go figure
		"delete": function(key) {
			if(key.__WeakMapKey === undefined || this.map[key.__WeakMapKey] === undefined) {
				return false;
			}
			
			this.length--;
			delete this.map[key.__WeakMapKey];
			
			return true;
		},
		
		has: function(key) {
			return key.__WeakMapKey !== undefined && this.map[key.__WeakMapKey] !== undefined;
		}
	}
}

/**
 * Polyfill for Map
 */
if(typeof Map !== 'function') {
  window.Map = function(pIterations) {
    this.size = 0;
    this._iterator = 0;
    this._keys = [];
    this._values = [];
    if (Array.isArray(pIterations) && pIterations.length > 0) {
      var that = this;
      pIterations.forEach(function(pValues){
        if (Array.isArray(pValues) === false || pValues.length !== 2) {
          throw new Error("input parameter must contains arrays of length two");
        }
        that._keys.push(pValues[0]);
        that._values.push(pValues[1]);
      })
    }
  },
  Map.prototype = {
		constructor: Map,
    clear: function(){
      this._keys = [];
      this._values = [];
      this.size = 0;
    },
    "delete": function(pKey){
      var index = this._keys.indexOf(pKey);
      if (index >= 0) {
        this._keys.splice(index, 1);
        this._values.splice(index, 1);
        this.size--;
        return true;
      }
      return false;
    },
    get: function(pKey) {
      var index = this._keys.indexOf(pKey);
      if (index >= 0) {
        return this._values[index];
      }
      return undefined;
    },
    has: function(pKey){
      return this._keys.includes(pKey);
    },
    set: function(pKey, pValue) {
      var index = this._keys.indexOf(pKey);
      if (index >= 0) {
        this._values[index] = pValue;
      } else {
        this._keys.push(pKey);
        this._values.push(pValue);
        this.size++;
      }
      return this;
    },
    next: function(){
      if (this._iterator < this.size) {
        var output = {
          value: [this._keys[this._iterator], this._values[this._iterator]],
          done: false
        }
        this._iterator++;
        return output;
      } else {
        return {
          value: [this._keys[this._iterator], this._values[this._iterator]],
          done: true
        }
      }
    },
    keys: function(){
      return this._keys.slice();
    },
    values: function(){
      return this._values.slice();
    },
    entries: function(){
      var that = this;
      var _keyValues = [];
      this._keys.forEach(function(pKey, pIndex){
        _keyValues.push([pKey, that._values[pIndex]]);
      });
      var output = {
        _iterationCount: 0,
        _keyValues: _keyValues,
        next: function(){
          if (this._iterationCount < this._keyValues.length) {
            var output = {
              value: this._keyValues[this._iterationCount],
              done: false
            }
            this._iterationCount++;
            return output;
          } else {
            return {
              value: this._keyValues[this._iterationCount],
              done: true
            }
          } 
        }
      }
      if (typeof Symbol !== "undefined") {
        output[Symbol.iterator] = function(){
          return this;
        }
      }
      return output;
    },
    forEach: function(pCallBackFunction, pThis) { //forEach((value, key, map) => { /* … */ } )
      for(var i=0; i<this._keys.length; i++) {
        pCallBackFunction.apply(pThis, [this._values[i], this._keys[i], this]);
      }
    },
    toString: function(){return "[object Map]";},
    toLocaleString: function(){return "[object Map]";}
  }

  if (typeof Symbol !== "undefined") {
    Map.prototype[Symbol.iterator] = function(){
      return this;
    }
  }
}

if (typeof WeakSet !== "function") {
  var counter = Date.now() % 1e9;
  /**
   * @constructor
   */
  window.WeakSet = function(data) {
    this.name = '__st' + (Math.random() * 1e9 >>> 0) + (counter++ + '__');
    data && data.forEach && data.forEach(this.add, this);
  };

  WeakSet.prototype = {
    add : function(val) {
      var name = this.name;
      if (!val[name]) {Object.defineProperty(val, name, {value: true, writable: true});}
      return this;
    },
    // delete has to be in quotes for IE8 - go figure
    "delete" : function(val) {
      if (!val[this.name]) {return false;}
      val[this.name] = undefined;
      return true;
    },
    has: function(val) {
      return !!val[this.name];
    }
  };
}

/**
 * Polyfill for CustomEvent
 * https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent
 */
(function() {
	if(typeof window.CustomEvent === "function")
		{return false;}
	function CustomEvent(event,params) {
		params = params || {
			bubbles: false,
			cancelable: false,
			detail: null
		};
		var evt = document.createEvent('CustomEvent');
		evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
		return evt;
	}
	window.CustomEvent = CustomEvent;
})();

/**
 * Polyfill for classList
 */
(function(window){ // prevent global namespace pollution
  if ("document" in self) {

    // Full polyfill for browsers with no classList support
    // Including IE < Edge missing SVGElement.classList
    if (
         !("classList" in document.createElement("_")) 
      || document.createElementNS
      && !("classList" in document.createElementNS("http://www.w3.org/2000/svg","g"))
    ) {
    
    (function (view) {
    
    "use strict";
    
    if (!('Element' in view)) {return;}
    
    var
        classListProp = "classList"
      , protoProp = "prototype"
      , elemCtrProto = view.Element[protoProp]
      , objCtr = Object
      , strTrim = String[protoProp].trim || function () {
        return this.replace(/^\s+|\s+$/g, "");
      }
      , arrIndexOf = Array[protoProp].indexOf || function (item) {
        var
            i = 0
          , len = this.length
        ;
        for (; i < len; i++) {
          if (i in this && this[i] === item) {
            return i;
          }
        }
        return -1;
      }
      // Vendors: please allow content code to instantiate DOMExceptions
      , DOMEx = function (type, message) {
        this.name = type;
        this.code = DOMException[type];
        this.message = message;
      }
      , checkTokenAndGetIndex = function (classList, token) {
        if (token === "") {
          throw new DOMEx(
              "SYNTAX_ERR"
            , "The token must not be empty."
          );
        }
        if (/\s/.test(token)) {
          throw new DOMEx(
              "INVALID_CHARACTER_ERR"
            , "The token must not contain space characters."
          );
        }
        return arrIndexOf.call(classList, token);
      }
      , ClassList = function (elem) {
        var
            trimmedClasses = strTrim.call(elem.getAttribute("class") || "")
          , classes = trimmedClasses ? trimmedClasses.split(/\s+/) : []
          , i = 0
          , len = classes.length
        ;
        for (; i < len; i++) {
          this.push(classes[i]);
        }
        this._updateClassName = function () {
          elem.setAttribute("class", this.toString());
        };
      }
      , classListProto = ClassList[protoProp] = []
      , classListGetter = function () {
        return new ClassList(this);
      }
    ;
    // Most DOMException implementations don't allow calling DOMException's toString()
    // on non-DOMExceptions. Error's toString() is sufficient here.
    DOMEx[protoProp] = Error[protoProp];
    classListProto.item = function (i) {
      return this[i] || null;
    };
    classListProto.contains = function (token) {
      return ~checkTokenAndGetIndex(this, token + "");
    };
    classListProto.add = function () {
      var
          tokens = arguments
        , i = 0
        , l = tokens.length
        , token
        , updated = false
      ;
      do {
        token = tokens[i] + "";
        if (!~checkTokenAndGetIndex(this, token)) {
          this.push(token);
          updated = true;
        }
      }
      while (++i < l);
    
      if (updated) {
        this._updateClassName();
      }
    };
    classListProto.remove = function () {
      var
          tokens = arguments
        , i = 0
        , l = tokens.length
        , token
        , updated = false
        , index
      ;
      do {
        token = tokens[i] + "";
        index = checkTokenAndGetIndex(this, token);
        while (~index) {
          this.splice(index, 1);
          updated = true;
          index = checkTokenAndGetIndex(this, token);
        }
      }
      while (++i < l);
    
      if (updated) {
        this._updateClassName();
      }
    };
    classListProto.toggle = function (token, force) {
      var
          result = this.contains(token)
        , method = result ?
          force !== true && "remove"
        :
          force !== false && "add"
      ;
    
      if (method) {
        this[method](token);
      }
    
      if (force === true || force === false) {
        return force;
      } else {
        return !result;
      }
    };
    classListProto.replace = function (token, replacement_token) {
      var index = checkTokenAndGetIndex(token + "");
      if (~index) {
        this.splice(index, 1, replacement_token);
        this._updateClassName();
      }
    }
    classListProto.toString = function () {
      return this.join(" ");
    };
    
    if (objCtr.defineProperty) {
      var classListPropDesc = {
          get: classListGetter
        , enumerable: true
        , configurable: true
      };
      try {
        objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
      } catch (ex) { // IE 8 doesn't support enumerable:true
        // adding undefined to fight this issue https://github.com/eligrey/classList.js/issues/36
        // modernie IE8-MSW7 machine has IE8 8.0.6001.18702 and is affected
        if (ex.number === undefined || ex.number === -0x7FF5EC54) {
          classListPropDesc.enumerable = false;
          objCtr.defineProperty(elemCtrProto, classListProp, classListPropDesc);
        }
      }
    } else if (objCtr[protoProp].__defineGetter__) {
      elemCtrProto.__defineGetter__(classListProp, classListGetter);
    }
    
    }(self));
    
    }
    
    // There is full or partial native classList support, so just check if we need
    // to normalize the add/remove and toggle APIs.
    
    (function () {
      "use strict";
    
      var testElement = document.createElement("_");
    
      testElement.classList.add("c1", "c2");
    
      // Polyfill for IE 10/11 and Firefox <26, where classList.add and
      // classList.remove exist but support only one argument at a time.
      if (!testElement.classList.contains("c2")) {
        var createMethod = function(method) {
          var original = DOMTokenList.prototype[method];
    
          DOMTokenList.prototype[method] = function(token) {
            var i, len = arguments.length;
    
            for (i = 0; i < len; i++) {
              token = arguments[i];
              original.call(this, token);
            }
          };
        };
        createMethod('add');
        createMethod('remove');
      }
    
      testElement.classList.toggle("c3", false);
    
      // Polyfill for IE 10 and Firefox <24, where classList.toggle does not
      // support the second argument.
      if (testElement.classList.contains("c3")) {
        var _toggle = DOMTokenList.prototype.toggle;
    
        DOMTokenList.prototype.toggle = function(token, force) {
          if (1 in arguments && !this.contains(token) === !force) {
            return force;
          } else {
            return _toggle.call(this, token);
          }
        };
    
      }
    
      // replace() polyfill
      if (!("replace" in document.createElement("_").classList)) {
        DOMTokenList.prototype.replace = function (token, replacement_token) {
          var
              tokens = this.toString().split(" ")
            , index = tokens.indexOf(token + "")
          ;
          if (~index) {
            tokens = tokens.slice(index);
            this.remove.apply(this, tokens);
            this.add(replacement_token);
            this.add.apply(this, tokens.slice(1));
          }
        }
      }
    
      testElement = null;
    }());
    
    }
})(window);

if (!window.structuredClone) {
(function(window) {
/*Copyright (c) 2021, Andrea Giammarchi, @WebReflection

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted, provided that the above
copyright notice and this permission notice appear in all copies.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE
OR OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.**/
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) {o = it;} var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) {return { done: true }}; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) {it["return"]();} } finally { if (didErr) {throw err;} } } }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) {return Array.from(iter);} }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) {return _arrayLikeToArray(arr);} }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) {return;} if (typeof o === "string") {return _arrayLikeToArray(o, minLen);} var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) {n = o.constructor.name;} if (n === "Map" || n === "Set") {return Array.from(o);} if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) {return _arrayLikeToArray(o, minLen);} }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) {len = arr.length;} for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) {return;} var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) {break;} } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) {_i["return"]();} } finally { if (_d) {throw _e;} } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) {return arr;} }

function _typeof(obj) {return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var VOID = -1;
var PRIMITIVE = 0;
var ARRAY = 1;
var OBJECT = 2;
var DATE = 3;
var REGEXP = 4;
var MAP = 5;
var SET = 6;
var ERROR = 7;
var BIGINT = 8;
var EMPTY = '';
var _ref = {},  toString = _ref.toString;
var keys = Object.keys;

var typeOf = function typeOf(value) {
  var type = _typeof(value);

  if (type !== 'object' || !value) {return [PRIMITIVE, type];}
  var asString = toString.call(value).slice(8, -1);

  switch (asString) {
    case 'Array':
      return [ARRAY, EMPTY];

    case 'Object':
      return [OBJECT, EMPTY];

    case 'Date':
      return [DATE, EMPTY];

    case 'RegExp':
      return [REGEXP, EMPTY];

    case 'Map':
      return [MAP, EMPTY];

    case 'Set':
      return [SET, EMPTY];
  }

  if (asString.includes('Array')) {return [ARRAY, asString];}
  if (asString.includes('Error')) {return [ERROR, asString];}
  return [OBJECT, asString];
};

var shouldSkip = function shouldSkip(_ref2) {
  var _ref3 = _slicedToArray(_ref2, 2),
      TYPE = _ref3[0],
      type = _ref3[1];

  return TYPE === PRIMITIVE && (type === 'function' || type === 'symbol');
};

var serializer = function serializer(strict, json, $, _) {
  var as = function as(out, value) {
    var index = _.push(out) - 1;
    $.set(value, index);
    return index;
  };

  var pair = function pair(value) {
    if ($.has(value)) {return $.get(value);}

    var _typeOf = typeOf(value),
        _typeOf2 = _slicedToArray(_typeOf, 2),
        TYPE = _typeOf2[0],
        type = _typeOf2[1];

    switch (TYPE) {
      case PRIMITIVE:
        {
          var entry = value;

          switch (type) {
            case 'bigint':
              TYPE = BIGINT;
              entry = value.toString();
              break;

            case 'function':
            case 'symbol':
              if (strict) {throw new TypeError('unable to serialize ' + type);}
              entry = null;
              break;

            case 'undefined':
              return as([VOID], value);
          }

          return as([TYPE, entry], value);
        }

      case ARRAY:
        {
          if (type) {return as([type, _toConsumableArray(value)], value);}
          var arr = [];
          var index = as([TYPE, arr], value);

          var _iterator = _createForOfIteratorHelper(value),
              _step;

          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var _entry = _step.value;
              arr.push(pair(_entry));
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }

          return index;
        }

      case OBJECT:
        {
          if (type) {
            switch (type) {
              case 'BigInt':
                return as([type, value.toString()], value);

              case 'Boolean':
              case 'Number':
              case 'String':
                return as([type, value.valueOf()], value);
            }
          }

          if (json && 'toJSON' in value) {return pair(value.toJSON());}
          var entries = [];

          var _index = as([TYPE, entries], value);

          var _iterator2 = _createForOfIteratorHelper(keys(value)),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var key = _step2.value;
              if (strict || !shouldSkip(typeOf(value[key]))) {entries.push([pair(key), pair(value[key])]);}
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }

          return _index;
        }

      case DATE:
        return as([TYPE, value.toISOString()], value);

      case REGEXP:
        {
          var source = value.source,
              flags = value.flags;
          return as([TYPE, {
            source: source,
            flags: flags
          }], value);
        }

      case MAP:
        {
          var _entries = [];

          var _index2 = as([TYPE, _entries], value);

          var _iterator3 = _createForOfIteratorHelper(value),
              _step3;

          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var _step3$value = _slicedToArray(_step3.value, 2),
                  _key = _step3$value[0],
                  _entry2 = _step3$value[1];

              if (strict || !(shouldSkip(typeOf(_key)) || shouldSkip(typeOf(_entry2)))) {_entries.push([pair(_key), pair(_entry2)]);}
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }

          return _index2;
        }

      case SET:
        {
          var _entries2 = [];

          var _index3 = as([TYPE, _entries2], value);

          var _iterator4 = _createForOfIteratorHelper(value),
              _step4;

          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              var _entry3 = _step4.value;
              if (strict || !shouldSkip(typeOf(_entry3))) {_entries2.push(pair(_entry3));}
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }

          return _index3;
        }
    }

    var message = value.message;
    return as([TYPE, {
      name: type,
      message: message
    }], value);
  };

  return pair;
};

var serialize = function serialize(value) {
  var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      json = _ref4.json,
      lossy = _ref4.lossy;

  var _ = [];
  return serializer(!(json || lossy), !!json, new Map(), _)(value), _;
};

var env = (typeof self === "undefined" ? "undefined" : _typeof(self)) === 'object' ? self : globalThis;

var deserializer = function deserializer($, _) {
  var as = function as(out, index) {
    $.set(index, out);
    return out;
  };

  var unpair = function unpair(index) {
    if ($.has(index)) {return $.get(index);}

    var _$index = _slicedToArray(_[index], 2),
        type = _$index[0],
        value = _$index[1];

    switch (type) {
      case PRIMITIVE:
      case VOID:
        return as(value, index);

      case ARRAY:
        {
          var arr = as([], index);

          var _iterator5 = _createForOfIteratorHelper(value),
              _step5;

          try {
            for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
              var _index4 = _step5.value;
              arr.push(unpair(_index4));
            }
          } catch (err) {
            _iterator5.e(err);
          } finally {
            _iterator5.f();
          }

          return arr;
        }

      case OBJECT:
        {
          var object = as({}, index);

          var _iterator6 = _createForOfIteratorHelper(value),
              _step6;

          try {
            for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
              var _step6$value = _slicedToArray(_step6.value, 2),
                  key = _step6$value[0],
                  _index5 = _step6$value[1];

              object[unpair(key)] = unpair(_index5);
            }
          } catch (err) {
            _iterator6.e(err);
          } finally {
            _iterator6.f();
          }

          return object;
        }

      case DATE:
        return as(new Date(value), index);

      case REGEXP:
        {
          var source = value.source,
              flags = value.flags;
          return as(new RegExp(source, flags), index);
        }

      case MAP:
        {
          var map = as(new Map(), index);

          var _iterator7 = _createForOfIteratorHelper(value),
              _step7;

          try {
            for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
              var _step7$value = _slicedToArray(_step7.value, 2),
                  _key2 = _step7$value[0],
                  _index6 = _step7$value[1];

              map.set(unpair(_key2), unpair(_index6));
            }
          } catch (err) {
            _iterator7.e(err);
          } finally {
            _iterator7.f();
          }

          return map;
        }

      case SET:
        {
          var set = as(new Set(), index);

          var _iterator8 = _createForOfIteratorHelper(value),
              _step8;

          try {
            for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
              var _index7 = _step8.value;
              set.add(unpair(_index7));
            }
          } catch (err) {
            _iterator8.e(err);
          } finally {
            _iterator8.f();
          }

          return set;
        }

      case ERROR:
        {
          var name = value.name,
              message = value.message;
          return as(new env[name](message), index);
        }

      case BIGINT:
        return as(BigInt(value), index);

      case 'BigInt':
        return as(Object(BigInt(value)), index);
    }

    return as(new env[type](value), index);
  };

  return unpair;
};

var deserialize = function deserialize(serialized) {
  return deserializer(new Map(), serialized)(0);
};

window.structuredClone = function(object, transferables) {
  if (transferables !== undefined) { console.error("polyfill structuredClone does not support transferables!"); }
  return deserialize(serialize(object));
}

})(window);
}
// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
// http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating

// requestAnimationFrame polyfill by Erik Möller. fixes from Paul Irish and Tino Zijdel

// MIT license
(function() {
  var lastTime = 0;
  var vendors = ['ms', 'moz', 'webkit', 'o'];
  for(var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
      window.requestAnimationFrame = window[vendors[x]+'RequestAnimationFrame'];
      window.cancelAnimationFrame = window[vendors[x]+'CancelAnimationFrame'] 
                                 || window[vendors[x]+'CancelRequestAnimationFrame'];
  }

  if (!window.requestAnimationFrame) {
      window.requestAnimationFrame = function(callback, element) {
          var currTime = new Date().getTime();
          var timeToCall = Math.max(0, 16 - (currTime - lastTime));
          var id = window.setTimeout(function() { callback(currTime + timeToCall); }, 
            timeToCall);
          lastTime = currTime + timeToCall;
          return id;
      };
  }
  if (!window.cancelAnimationFrame) {
      window.cancelAnimationFrame = function(id) {
          clearTimeout(id);
      };
  }
}());
// https://github.com/taylorhakes/promise-polyfill version 8.3.0
!function(e,t){"object"==typeof exports&&"undefined"!=typeof module?t():"function"==typeof define&&define.amd?define(t):t()}(0,function(){"use strict";function e(e){var t=this.constructor;return this.then(function(n){return t.resolve(e()).then(function(){return n})},function(n){return t.resolve(e()).then(function(){return t.reject(n)})})}function t(e){return new this(function(t,n){function r(e,n){if(n&&("object"==typeof n||"function"==typeof n)){var f=n.then;if("function"==typeof f)return void f.call(n,function(t){r(e,t)},function(n){o[e]={status:"rejected",reason:n},0==--i&&t(o)})}o[e]={status:"fulfilled",value:n},0==--i&&t(o)}if(!e||"undefined"==typeof e.length)return n(new TypeError(typeof e+" "+e+" is not iterable(cannot read property Symbol(Symbol.iterator))"));var o=Array.prototype.slice.call(e);if(0===o.length)return t([]);for(var i=o.length,f=0;o.length>f;f++)r(f,o[f])})}function n(e,t){this.name="AggregateError",this.errors=e,this.message=t||""}function r(e){var t=this;return new t(function(r,o){if(!e||"undefined"==typeof e.length)return o(new TypeError("Promise.any accepts an array"));var i=Array.prototype.slice.call(e);if(0===i.length)return o();for(var f=[],u=0;i.length>u;u++)try{t.resolve(i[u]).then(r)["catch"](function(e){f.push(e),f.length===i.length&&o(new n(f,"All promises were rejected"))})}catch(c){o(c)}})}function o(e){return!(!e||"undefined"==typeof e.length)}function i(){}function f(e){if(!(this instanceof f))throw new TypeError("Promises must be constructed via new");if("function"!=typeof e)throw new TypeError("not a function");this._state=0,this._handled=!1,this._value=undefined,this._deferreds=[],s(e,this)}function u(e,t){for(;3===e._state;)e=e._value;0!==e._state?(e._handled=!0,f._immediateFn(function(){var n=1===e._state?t.onFulfilled:t.onRejected;if(null!==n){var r;try{r=n(e._value)}catch(o){return void a(t.promise,o)}c(t.promise,r)}else(1===e._state?c:a)(t.promise,e._value)})):e._deferreds.push(t)}function c(e,t){try{if(t===e)throw new TypeError("A promise cannot be resolved with itself.");if(t&&("object"==typeof t||"function"==typeof t)){var n=t.then;if(t instanceof f)return e._state=3,e._value=t,void l(e);if("function"==typeof n)return void s(function(e,t){return function(){e.apply(t,arguments)}}(n,t),e)}e._state=1,e._value=t,l(e)}catch(r){a(e,r)}}function a(e,t){e._state=2,e._value=t,l(e)}function l(e){2===e._state&&0===e._deferreds.length&&f._immediateFn(function(){e._handled||f._unhandledRejectionFn(e._value)});for(var t=0,n=e._deferreds.length;n>t;t++)u(e,e._deferreds[t]);e._deferreds=null}function s(e,t){var n=!1;try{e(function(e){n||(n=!0,c(t,e))},function(e){n||(n=!0,a(t,e))})}catch(r){if(n)return;n=!0,a(t,r)}}n.prototype=Error.prototype;var d=setTimeout;f.prototype["catch"]=function(e){return this.then(null,e)},f.prototype.then=function(e,t){var n=new this.constructor(i);return u(this,new function(e,t,n){this.onFulfilled="function"==typeof e?e:null,this.onRejected="function"==typeof t?t:null,this.promise=n}(e,t,n)),n},f.prototype["finally"]=e,f.all=function(e){return new f(function(t,n){function r(e,o){try{if(o&&("object"==typeof o||"function"==typeof o)){var u=o.then;if("function"==typeof u)return void u.call(o,function(t){r(e,t)},n)}i[e]=o,0==--f&&t(i)}catch(c){n(c)}}if(!o(e))return n(new TypeError("Promise.all accepts an array"));var i=Array.prototype.slice.call(e);if(0===i.length)return t([]);for(var f=i.length,u=0;i.length>u;u++)r(u,i[u])})},f.any=r,f.allSettled=t,f.resolve=function(e){return e&&"object"==typeof e&&e.constructor===f?e:new f(function(t){t(e)})},f.reject=function(e){return new f(function(t,n){n(e)})},f.race=function(e){return new f(function(t,n){if(!o(e))return n(new TypeError("Promise.race accepts an array"));for(var r=0,i=e.length;i>r;r++)f.resolve(e[r]).then(t,n)})},f._immediateFn="function"==typeof setImmediate&&function(e){setImmediate(e)}||function(e){d(e,0)},f._unhandledRejectionFn=function(e){void 0!==console&&console&&console.warn("Possible Unhandled Promise Rejection:",e)};var p=function(){if("undefined"!=typeof self)return self;if("undefined"!=typeof window)return window;if("undefined"!=typeof global)return global;throw Error("unable to locate global object")}();"function"!=typeof p.Promise?p.Promise=f:(p.Promise.prototype["finally"]||(p.Promise.prototype["finally"]=e),p.Promise.allSettled||(p.Promise.allSettled=t),p.Promise.any||(p.Promise.any=r))});
if (typeof Promise.withResolvers === "undefined") {
  Promise.withResolvers = function () {
    var resolve, reject;
    var promise = new Promise(function(res, rej){
      resolve = res;
      reject = rej;
    })
    return { promise, resolve, reject }
  }
}
if (window.Promise.try === undefined) {
  window.Promise.try = function(pFc){
    try {
      var args = [];
      for(var i=1; i<arguments.length;i++) {
        args.push(arguments[i]);
      }
      return Promise.resolve(pFc.apply(null, args));
    } catch(e) {
      return Promise.reject(e);
    }
  }
}
// some fetch polyfill
if (typeof window.fetch !== "function" && typeof window.XMLHttpRequest === "function") {
  window.fetch = function(url, options){
    return new Promise(function(resolve, reject) {
      var xhr = new XMLHttpRequest();

      xhr.onload = function() {
        // Check for HTTP success (status in the range of 200 to 299)
        if (xhr.status >= 200 && xhr.status < 300) {
          resolve(new Response(xhr.responseText, { status: xhr.status }));
        } else {
          // Create a new Error object with more information
          var error = new Error(xhr.statusText);
          error.response = new Response(xhr.responseText, { status: xhr.status });
          reject(error);
        }
      };

      xhr.onerror = function() {
        reject(new Error("Network error"));
      };

      // open(method, url, async)
      xhr.open(options.method || "GET", url, true);

      // We must call setRequestHeader() after open(), but before send().
      for (var header in options.headers || {}) {
        xhr.setRequestHeader(header, options.headers[header]);
      }

      xhr.send(options.body || null);
    });
  }
}

/**!
 * url-search-params-polyfill
 *
 * @author Jerry Bendy (https://github.com/jerrybendy)
 * @licence MIT
 */
(function(self) {
  'use strict';

  var nativeURLSearchParams = (function() {
        // #41 Fix issue in RN
        try {
            if (self.URLSearchParams && (new self.URLSearchParams('foo=bar')).get('foo') === 'bar') {
                return self.URLSearchParams;
            }
        } catch (e) {}
        return null;
    })(),
    isSupportObjectConstructor = nativeURLSearchParams && (new nativeURLSearchParams({a: 1})).toString() === 'a=1',
    // There is a bug in safari 10.1 (and earlier) that incorrectly decodes `%2B` as an empty space and not a plus.
    decodesPlusesCorrectly = nativeURLSearchParams && (new nativeURLSearchParams('s=%2B').get('s') === '+'),
    isSupportSize = nativeURLSearchParams && 'size' in nativeURLSearchParams.prototype,
    __URLSearchParams__ = "__URLSearchParams__",
    // Fix bug in Edge which cannot encode ' &' correctly
    encodesAmpersandsCorrectly = nativeURLSearchParams ? (function() {
        var ampersandTest = new nativeURLSearchParams();
        ampersandTest.append('s', ' &');
        return ampersandTest.toString() === 's=+%26';
    })() : true,
    prototype = URLSearchParamsPolyfill.prototype,
    iterable = !!(self.Symbol && self.Symbol.iterator);

  if (nativeURLSearchParams && isSupportObjectConstructor && decodesPlusesCorrectly && encodesAmpersandsCorrectly && isSupportSize) {
      return;
  }

  function URLSearchParamsPolyfill(search) {
      search = search || "";

      // support construct object with another URLSearchParams instance
      if (search instanceof URLSearchParams || search instanceof URLSearchParamsPolyfill) {
          search = search.toString();
      }
      this [__URLSearchParams__] = parseToDict(search);
  }

  prototype.append = function(name, value) {
      appendTo(this [__URLSearchParams__], name, value);
  };

  prototype['delete'] = function(name) {
      delete this [__URLSearchParams__] [name];
  };

  prototype.get = function(name) {
      var dict = this [__URLSearchParams__];
      return this.has(name) ? dict[name][0] : null;
  };

  prototype.getAll = function(name) {
      var dict = this [__URLSearchParams__];
      return this.has(name) ? dict [name].slice(0) : [];
  };

  prototype.has = function(name) {
      return hasOwnProperty(this [__URLSearchParams__], name);
  };

  prototype.set = function set(name, value) {
      this [__URLSearchParams__][name] = ['' + value];
  };

  prototype.toString = function() {
      var dict = this[__URLSearchParams__], query = [], i, key, name, value;
      for (key in dict) {
          name = encode(key);
          for (i = 0, value = dict[key]; i < value.length; i++) {
              query.push(name + '=' + encode(value[i]));
          }
      }
      return query.join('&');
  };

  // There is a bug in Safari 10.1 and `Proxy`ing it is not enough.
  var useProxy = self.Proxy && nativeURLSearchParams && (!decodesPlusesCorrectly || !encodesAmpersandsCorrectly || !isSupportObjectConstructor || !isSupportSize);
  var propValue;
  if (useProxy) {
      // Safari 10.0 doesn't support Proxy, so it won't extend URLSearchParams on safari 10.0
      propValue = new Proxy(nativeURLSearchParams, {
          construct: function (target, args) {
              return new target((new URLSearchParamsPolyfill(args[0]).toString()));
          }
      })
      // Chrome <=60 .toString() on a function proxy got error "Function.prototype.toString is not generic"
      propValue.toString = Function.prototype.toString.bind(URLSearchParamsPolyfill);
  } else {
      propValue = URLSearchParamsPolyfill;
  }

  /*
   * Apply polyfill to global object and append other prototype into it
   */
  Object.defineProperty(self, 'URLSearchParams', {
      value: propValue
  });

  var USPProto = self.URLSearchParams.prototype;

  USPProto.polyfill = true;

  // Fix #54, `toString.call(new URLSearchParams)` will return correct value when Proxy not used
  if (!useProxy && self.Symbol) {
      USPProto[self.Symbol.toStringTag] = 'URLSearchParams';
  }

  if (!('forEach' in USPProto)) {
      USPProto.forEach = function(callback, thisArg) {
          var dict = parseToDict(this.toString());
          Object.getOwnPropertyNames(dict).forEach(function(name) {
              dict[name].forEach(function(value) {
                  callback.call(thisArg, value, name, this);
              }, this);
          }, this);
      };
  }

  if (!('sort' in USPProto)) {
      USPProto.sort = function() {
          var dict = parseToDict(this.toString()), keys = [], k, i, j;
          for (k in dict) {
              keys.push(k);
          }
          keys.sort();

          for (i = 0; i < keys.length; i++) {
              this['delete'](keys[i]);
          }
          for (i = 0; i < keys.length; i++) {
              var key = keys[i], values = dict[key];
              for (j = 0; j < values.length; j++) {
                  this.append(key, values[j]);
              }
          }
      };
  }

  if (!('keys' in USPProto)) {
      USPProto.keys = function() {
          var items = [];
          this.forEach(function(item, name) {
              items.push(name);
          });
          return makeIterator(items);
      };
  }

  if (!('values' in USPProto)) {
      USPProto.values = function() {
          var items = [];
          this.forEach(function(item) {
              items.push(item);
          });
          return makeIterator(items);
      };
  }

  if (!('entries' in USPProto)) {
      USPProto.entries = function() {
          var items = [];
          this.forEach(function(item, name) {
              items.push([name, item]);
          });
          return makeIterator(items);
      };
  }

  if (iterable) {
      USPProto[self.Symbol.iterator] = USPProto[self.Symbol.iterator] || USPProto.entries;
  }

  if (!('size' in USPProto)) {
      Object.defineProperty(USPProto, 'size', {
          get: function () {
              var dict = parseToDict(this.toString())
              if (USPProto === this) {
                  throw new Error('Illegal invocation at URLSearchParams.invokeGetter')
              }
              return Object.keys(dict).reduce(function (prev, cur) {
                  return prev + dict[cur].length;
              }, 0);
          }
      });
  }

  function encode(str) {
      var replace = {
          '!': '%21',
          "'": '%27',
          '(': '%28',
          ')': '%29',
          '~': '%7E',
          '%20': '+',
          '%00': '\x00'
      };
      return encodeURIComponent(str).replace(/[!'\(\)~]|%20|%00/g, function(match) {
          return replace[match];
      });
  }

  function decode(str) {
      return str
          .replace(/[ +]/g, '%20')
          .replace(/(%[a-f0-9]{2})+/ig, function(match) {
              return decodeURIComponent(match);
          });
  }

  function makeIterator(arr) {
      var iterator = {
          next: function() {
              var value = arr.shift();
              return {done: value === undefined, value: value};
          }
      };

      if (iterable) {
          iterator[self.Symbol.iterator] = function() {
              return iterator;
          };
      }

      return iterator;
  }

  function parseToDict(search) {
      var dict = {};

      if (typeof search === "object") {
          // if `search` is an array, treat it as a sequence
          if (isArray(search)) {
              for (var i = 0; i < search.length; i++) {
                  var item = search[i];
                  if (isArray(item) && item.length === 2) {
                      appendTo(dict, item[0], item[1]);
                  } else {
                      throw new Error("Failed to construct 'URLSearchParams': Sequence initializer must only contain pair elements");
                  }
              }

          } else {
              for (var key in search) {
                  if (search.hasOwnProperty(key)) {
                      appendTo(dict, key, search[key]);
                  }
              }
          }

      } else {
          // remove first '?'
          if (search.indexOf("?") === 0) {
              search = search.slice(1);
          }

          var pairs = search.split("&");
          for (var j = 0; j < pairs.length; j++) {
              var value = pairs [j],
                  index = value.indexOf('=');

              if (-1 < index) {
                  appendTo(dict, decode(value.slice(0, index)), decode(value.slice(index + 1)));

              } else {
                  if (value) {
                      appendTo(dict, decode(value), '');
                  }
              }
          }
      }

      return dict;
  }

  function appendTo(dict, name, value) {
      var val = typeof value === 'string' ? value : (
          value !== null && value !== undefined && typeof value.toString === 'function' ? value.toString() : JSON.stringify(value)
      );

      // #47 Prevent using `hasOwnProperty` as a property name
      if (hasOwnProperty(dict, name)) {
          dict[name].push(val);
      } else {
          dict[name] = [val];
      }
  }

  function isArray(val) {
      return !!val && '[object Array]' === Object.prototype.toString.call(val);
  }

  function hasOwnProperty(obj, prop) {
      return Object.prototype.hasOwnProperty.call(obj, prop);
  }

})(typeof global !== 'undefined' ? global : (typeof window !== 'undefined' ? window : this));

if (typeof window.AbortController === "undefined") {
  var SECRET = {};

  window.AbortSignal = (function () {
    function AbortSignal(secret) {
      if (secret !== SECRET) {
        throw new Error("Illegal constructor.");
      }
      EventTarget.call(this);
      this._aborted = false;
    }

    AbortSignal.prototype = Object.create(EventTarget.prototype);
    AbortSignal.prototype.constructor = AbortSignal;

    Object.defineProperty(AbortSignal.prototype, "onabort", {
      get: function () {
        return this._onabort;
      },
      set: function (callback) {
        const existing = this._onabort;
        if (existing) {
          this.removeEventListener("abort", existing);
        }
        this._onabort = callback;
        this.addEventListener("abort", callback);
      },
    });

    Object.defineProperty(AbortSignal.prototype, "aborted", {
      get: function () {
        return this._aborted;
      },
    });

    return AbortSignal;
  })();

  window.AbortController = (function () {
    function AbortController() {
      this._signal = new AbortSignal(SECRET);
    }

    AbortController.prototype = Object.create(Object.prototype);

    Object.defineProperty(AbortController.prototype, "signal", {
      get: function () {
        return this._signal;
      },
    });

    AbortController.prototype.abort = function () {
      const signal = this.signal;
      if (!signal.aborted) {
        signal._aborted = true;
        signal.dispatchEvent(new Event("abort"));
      }
    };

    return AbortController;
  })();
}

if (window.atob === undefined) {
  /*! https://mths.be/base64 v1.0.0 by @mathias | MIT license */
  ; (function (root) {

    // Detect free variables `exports`.
    var freeExports = typeof exports == 'object' && exports;

    // Detect free variable `module`.
    var freeModule = typeof module == 'object' && module &&
      module.exports == freeExports && module;

    // Detect free variable `global`, from Node.js or Browserified code, and use
    // it as `root`.
    var freeGlobal = typeof global == 'object' && global;
    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) {
      root = freeGlobal;
    }

    /*--------------------------------------------------------------------------*/

    var InvalidCharacterError = function (message) {
      this.message = message;
    };
    InvalidCharacterError.prototype = new Error;
    InvalidCharacterError.prototype.name = 'InvalidCharacterError';

    var error = function (message) {
      // Note: the error messages used throughout this file match those used by
      // the native `atob`/`btoa` implementation in Chromium.
      throw new InvalidCharacterError(message);
    };

    var TABLE = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
    // http://whatwg.org/html/common-microsyntaxes.html#space-character
    var REGEX_SPACE_CHARACTERS = /[\t\n\f\r ]/g;

    // `decode` is designed to be fully compatible with `atob` as described in the
    // HTML Standard. http://whatwg.org/html/webappapis.html#dom-windowbase64-atob
    // The optimized base64-decoding algorithm used is based on @atk’s excellent
    // implementation. https://gist.github.com/atk/1020396
    var decode = function (input) {
      input = String(input)
        .replace(REGEX_SPACE_CHARACTERS, '');
      var length = input.length;
      if (length % 4 == 0) {
        input = input.replace(/==?$/, '');
        length = input.length;
      }
      if (
        length % 4 == 1 ||
        // http://whatwg.org/C#alphanumeric-ascii-characters
        /[^+a-zA-Z0-9/]/.test(input)
      ) {
        error(
          'Invalid character: the string to be decoded is not correctly encoded.'
        );
      }
      var bitCounter = 0;
      var bitStorage;
      var buffer;
      var output = '';
      var position = -1;
      while (++position < length) {
        buffer = TABLE.indexOf(input.charAt(position));
        bitStorage = bitCounter % 4 ? bitStorage * 64 + buffer : buffer;
        // Unless this is the first of a group of 4 characters…
        if (bitCounter++ % 4) {
          // …convert the first 8 bits to a single ASCII character.
          output += String.fromCharCode(
            0xFF & bitStorage >> (-2 * bitCounter & 6)
          );
        }
      }
      return output;
    };

    // `encode` is designed to be fully compatible with `btoa` as described in the
    // HTML Standard: http://whatwg.org/html/webappapis.html#dom-windowbase64-btoa
    var encode = function (input) {
      input = String(input);
      if (/[^\0-\xFF]/.test(input)) {
        // Note: no need to special-case astral symbols here, as surrogates are
        // matched, and the input is supposed to only contain ASCII anyway.
        error(
          'The string to be encoded contains characters outside of the ' +
          'Latin1 range.'
        );
      }
      var padding = input.length % 3;
      var output = '';
      var position = -1;
      var a;
      var b;
      var c;
      var buffer;
      // Make sure any padding is handled outside of the loop.
      var length = input.length - padding;

      while (++position < length) {
        // Read three bytes, i.e. 24 bits.
        a = input.charCodeAt(position) << 16;
        b = input.charCodeAt(++position) << 8;
        c = input.charCodeAt(++position);
        buffer = a + b + c;
        // Turn the 24 bits into four chunks of 6 bits each, and append the
        // matching character for each of them to the output.
        output += (
          TABLE.charAt(buffer >> 18 & 0x3F) +
          TABLE.charAt(buffer >> 12 & 0x3F) +
          TABLE.charAt(buffer >> 6 & 0x3F) +
          TABLE.charAt(buffer & 0x3F)
        );
      }

      if (padding == 2) {
        a = input.charCodeAt(position) << 8;
        b = input.charCodeAt(++position);
        buffer = a + b;
        output += (
          TABLE.charAt(buffer >> 10) +
          TABLE.charAt((buffer >> 4) & 0x3F) +
          TABLE.charAt((buffer << 2) & 0x3F) +
          '='
        );
      } else if (padding == 1) {
        buffer = input.charCodeAt(position);
        output += (
          TABLE.charAt(buffer >> 2) +
          TABLE.charAt((buffer << 4) & 0x3F) +
          '=='
        );
      }

      return output;
    };

    if (window.atob === undefined) {
      root.atob = decode;
    }
    if (window.btoa === undefined) {
      root.btoa = encode;
    }

  }(window));
}

if (window.queueMicrotask == undefined) {
  window.queueMicrotask = function(pCallBackFunction) {
    if (typeof pCallBackFunction !== "function") {
      throw new Error("Failed to execute 'queueMicrotask' on 'Window': parameter 1 is not of type 'Function'.");
    }
    if (typeof Promise === "function" && typeof Promise.resolve === "function") {
      return Promise.resolve().then(pCallBackFunction)
      .catch(function(e){ 
        setTimeout(function(){ throw e; });
      });
    } else {
      setTimeout(pCallBackFunction, 0);
    }
  }
}

/*
if (window.CSSNumericValue === undefined) {
  window.CSSNumericValue = function(value, unit) {
    this.value = Number(value);
    this.unit = unit || "";
  };
  window.CSSNumericValue.parse = function(input) {
    if (input instanceof window.CSSNumericValue) {return input;}
    var match = ("" + input).trim().match(/^(-?\d*\.?\d+)([a-z%]*)$/i);
    if (!match) {
      throw new TypeError("Invalid CSS numeric value: " + input);
    }
    return new window.CSSNumericValue(match[1], match[2]);
  }
  window.CSSNumericValue.prototype = { 
    constructor: window.CSSNumericValue,
    add: function(other) {
      if (!(other instanceof window.CSSNumericValue)) {
        throw new Error("Uncaught TypeError: Failed to execute 'add' on 'CSSNumericValue': The provided double value is non-finite.");
      }
      if (this.unit === other.unit) {
        return new window.CSSNumericValue(this.value + other.value, this.unit);
      } else {
        return {operator: "sum", values:[this, other]};
      }
    },
    sub: function(other) {
      if (!(other instanceof window.CSSNumericValue)) {
        throw new Error("Uncaught TypeError: Failed to execute 'sub' on 'CSSNumericValue': The provided double value is non-finite.");
      }
      if (this.unit === other.unit) {
        return new window.CSSNumericValue(this.value - other.value, this.unit);
      } else {
        return {operator: "sum", values:[this, new window.CSSUnitValue(-other.value, other.unit)]};
      }
    },
    mul: function(number) {
      if (typeof number === 'number') {
        return new window.CSSNumericValue(this.value * number, this.unit);
      }
      return {operator: "product", values:[this, other]};
    },
    div: function(number) {
      if (typeof number === 'number') {
        return new window.CSSNumericValue(this.value / number, this.unit);
      }
      return {operator: "product", values:[this, {operator: "invert", value: other}]};
    },
    equals: function(other){
      if (!(other instanceof window.CSSNumericValue)) { return false; }
      return other.value === this.value && other.unit === this.unit;
    },
    min: function(){},
    max: function(){},
    to: function(){},
    toSum: function(){},
    type: function(){}
  }
}
*/
if (window.CSSUnitValue === undefined && typeof CSSUnitValue !== "function") {
  var unitNames = ["Hz","Q","cap","ch","cm","cqb","cqh","cqi","cqmax","cqmin","cqw","deg","dpcm","dpi","dppx","dvb","dvh","dvi","dvmax","dvmin","dvw","em","ex","fr","grad","ic","in","kHz","lh","lvb","lvh","lvi","lvmax","lvmin","lvw","mm","ms","number","pc","percent","pt","px","rad","rcap","rch","rem","rex","ric","rlh","s","svb","svh","svi","svmax","svmin","svw","turn","vb","vh","vi","vmax","vmin","vw","x"];
  window.CSSUnitValue = function(pValue, pUnit){
    if (typeof pUnit !== "string" || pUnit.length <= 0 || unitNames.indexOf(pUnit) === -1 ) {
      throw new Error("Failed to construct 'CSSUnitValue': Invalid unit: "+ pUnit);
    }
    this.unit = pUnit;
    this.value = parseFloat(pValue);   
    if (isNaN(this.value)) {
      throw new Error("Failed to construct 'CSSUnitValue': The provided double value is non-finite.");
    }
  }
  window.CSSUnitValue.prototype = {
    constructor: window.CSSUnitValue,
    toString: function() {return this.value + this.unit;},
  }
}
if (window.CSS === undefined) {
  window.CSS = {
    supports: function(){return false},
    escape: function(value) {
      return value.replace(/([!"#$%&'()*+,.\/:;<=>?@[\\\]^`{|}~])/g, "\\$1");
    }
  }
  if (window.CSSUnitValue !== undefined){
    var unitNames = ["Hz","Q","cap","ch","cm","cqb","cqh","cqi","cqmax","cqmin","cqw","deg","dpcm","dpi","dppx","dvb","dvh","dvi","dvmax","dvmin","dvw","em","ex","fr","grad","ic","in","kHz","lh","lvb","lvh","lvi","lvmax","lvmin","lvw","mm","ms","number","pc","percent","pt","px","rad","rcap","rch","rem","rex","ric","rlh","s","svb","svh","svi","svmax","svmin","svw","turn","vb","vh","vi","vmax","vmin","vw","x"];
    // we assume that array.foreach is polyfilled before!
    unitNames.forEach(function(pUnit){
      window.CSS[pUnit] = function(pValue){
        return new window.CSSUnitValue(pValue, pUnit);
      }
    })
  }
}

// support for older pages with older jquery versions
if (window.$ !== undefined && window.jQuery !== undefined) { // if jquery present
  if ($.Deferred !== undefined) { // if Deferred present and not some self made $
    if ($.Deferred().catch === undefined){ // if catch function missing, this means an old jQuery
      var originalDeferred = $.Deferred;
      $.Deferred = function(){ 
          var deferred = originalDeferred.apply($, arguments);
          deferred["catch"] = function( fn ) {
            return deferred.then( null, fn );
          };
          deferred.promise(null)["catch"] = function( fn ) {
            return deferred.then( null, fn );
          };
          return deferred;
      }
      // extend to also accept thenables (including Promise)
      var originalWhen = $.when;
      $.when = function() {
          var parameters = [];
          for(var i=0; i<arguments.length; i++) {
            if (arguments[i] !== undefined && arguments[i] !== null && typeof arguments[i].then === "function" && arguments[i].promise === undefined) {
              (function(thenable){
                parameters.push($.Deferred(function(d){thenable.then(d.resolve, d.reject)}));
              })( arguments[i] )
            } else {
              parameters.push(arguments[i]);
            }
          }
          return originalWhen.apply($, parameters)
      }
    }
  }
  if (jQuery.fn.jquery === "1.8.3") {
    Promise.origReject = Promise.reject; 
    Promise.reject = function(pArg){
        this.origReject(pArg);
        return $.Deferred().reject(pArg);
    }
  }
  if ($.isArray === undefined) {
    $.isArray = function(pInput){console.warn("$.isArray is deprecated");return Array.isArray(pInput);};
  }
  if ($.isFunction === undefined) {
    $.isFunction = function(f){console.warn("$.isFunction is deprecated");return typeof f === "function";};
  }
  if ($.trim === undefined) {
    $.trim = function(pContent){
      console.warn("$.trim is deprecated");
      if (typeof pContent === "string" && typeof pContent.trim === "function") {
        return pContent.trim();
      }
      return pContent;
    }
  }
  if ($.parseJSON === undefined) {
    $.parseJSON = function(pInput){console.warn("$.parseJSON is deprecated");return JSON.parse(pInput);};
  }
  if ($.Widget !== undefined) { // if jquery UI is present
    if ($.Widget.prototype._addClass === undefined) { // if jQuery UI is older then < 1.13
      $.Widget.prototype.classesElementLookup = {};
      $.Widget.prototype._classes = function( options ) {
        var full = [];
        var that = this;
    
        options = $.extend( {
          element: this.element,
          classes: this.options.classes || {}
        }, options );
    
        function bindRemoveEvent() {
          var nodesToBind = [];
    
          options.element.each( function( _, element ) {
            var isTracked = $.map( that.classesElementLookup, function( elements ) {
              return elements;
            } )
              .some( function( elements ) {
                return elements.is( element );
              } );
    
            if ( !isTracked ) {
              nodesToBind.push( element );
            }
          } );
    
          that._on( $( nodesToBind ), {
            remove: "_untrackClassesElement"
          } );
        }
    
        function processClassString( classes, checkOption ) {
          var current, i;
          for ( i = 0; i < classes.length; i++ ) {
            current = that.classesElementLookup[ classes[ i ] ] || $();
            if ( options.add ) {
              bindRemoveEvent();
              var value = current.get().concat( options.element.get() );
              if (value !== undefined) {
                if (typeof $.uniqueSort === "function") {
                  current = $( $.uniqueSort( value ) );
                } else if (typeof $.unique === "function") {
                  current = $( $.unique( value ) );
                }
              }
            } else {
              current = $( current.not( options.element ).get() );
            }
            that.classesElementLookup[ classes[ i ] ] = current;
            full.push( classes[ i ] );
            if ( checkOption && options.classes[ classes[ i ] ] ) {
              full.push( options.classes[ classes[ i ] ] );
            }
          }
        }
    
        if ( options.keys ) {
          processClassString( options.keys.match( /\S+/g ) || [], true );
        }
        if ( options.extra ) {
          processClassString( options.extra.match( /\S+/g ) || [] );
        }
    
        return full.join( " " );
      };
      $.Widget.prototype._removeClass = function( element, keys, extra ) {
          return this._toggleClass( element, keys, extra, false );
      };
      $.Widget.prototype._addClass = function( element, keys, extra ) {
        return this._toggleClass( element, keys, extra, true );
      };
      $.Widget.prototype._toggleClass = function( element, keys, extra, add ) {
        add = ( typeof add === "boolean" ) ? add : extra;
        var shift = ( typeof element === "string" || element === null ),
          options = {
            extra: shift ? keys : extra,
            keys: shift ? element : keys,
            element: shift ? this.element : element,
            add: add
          };
        options.element.toggleClass( this._classes( options ), add );
        return this;
      }
    }
  }
}

/* eslint-disable no-undef, no-extend-native, no-restricted-properties */
(function() {
  if (typeof globalThis === 'object') {
    return;
  }
  Object.prototype.__defineGetter__('__magic__', function() {
    return this;
  });
  __magic__.globalThis = __magic__;
  delete Object.prototype.__magic__;
}());
/* eslint-enable no-undef, no-extend-native, no-restricted-properties */